import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  date: { input: string; output: string; }
  json: { input: Record<string, unknown> | unknown[]; output: Record<string, unknown> | unknown[]; }
  jsonb: { input: Record<string, unknown> | unknown[]; output: Record<string, unknown> | unknown[]; }
  timestamp: { input: string; output: string; }
  timestamptz: { input: string; output: string; }
  uuid: { input: string; output: string; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "authConnectionTypes". All fields are combined with a logical 'AND'. */
export type AuthConnectionTypes_Bool_Exp = {
  _and?: InputMaybe<Array<AuthConnectionTypes_Bool_Exp>>;
  _not?: InputMaybe<AuthConnectionTypes_Bool_Exp>;
  _or?: InputMaybe<Array<AuthConnectionTypes_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "authConnectionTypes" */
export type AuthConnectionTypes_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'authConnectionTypes_pkey';

export type AuthConnectionTypes_Enum =
  | 'EMAIL'
  | 'OPENID_CONNECT'
  | 'SAML';

/** Boolean expression to compare columns of type "authConnectionTypes_enum". All fields are combined with logical 'AND'. */
export type AuthConnectionTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<AuthConnectionTypes_Enum>;
  _in?: InputMaybe<Array<AuthConnectionTypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AuthConnectionTypes_Enum>;
  _nin?: InputMaybe<Array<AuthConnectionTypes_Enum>>;
};

/** input type for inserting data into table "authConnectionTypes" */
export type AuthConnectionTypes_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** on_conflict condition type for table "authConnectionTypes" */
export type AuthConnectionTypes_On_Conflict = {
  constraint: AuthConnectionTypes_Constraint;
  update_columns?: Array<AuthConnectionTypes_Update_Column>;
  where?: InputMaybe<AuthConnectionTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "authConnectionTypes". */
export type AuthConnectionTypes_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: authConnectionTypes */
export type AuthConnectionTypes_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "authConnectionTypes" */
export type AuthConnectionTypes_Select_Column =
  /** column name */
  | 'id';

/** input type for updating data in table "authConnectionTypes" */
export type AuthConnectionTypes_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authConnectionTypes" */
export type AuthConnectionTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthConnectionTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthConnectionTypes_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "authConnectionTypes" */
export type AuthConnectionTypes_Update_Column =
  /** column name */
  | 'id';

export type AuthConnectionTypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthConnectionTypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthConnectionTypes_Bool_Exp;
};

/** Boolean expression to filter rows from the table "authConnectionUiTypes". All fields are combined with a logical 'AND'. */
export type AuthConnectionUiTypes_Bool_Exp = {
  _and?: InputMaybe<Array<AuthConnectionUiTypes_Bool_Exp>>;
  _not?: InputMaybe<AuthConnectionUiTypes_Bool_Exp>;
  _or?: InputMaybe<Array<AuthConnectionUiTypes_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "authConnectionUiTypes" */
export type AuthConnectionUiTypes_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'authConnectionUiTypes_pkey';

export type AuthConnectionUiTypes_Enum =
  | 'CUSTOM'
  | 'DEFAULT'
  | 'EMAIL'
  | 'GOOGLE';

/** Boolean expression to compare columns of type "authConnectionUiTypes_enum". All fields are combined with logical 'AND'. */
export type AuthConnectionUiTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<AuthConnectionUiTypes_Enum>;
  _in?: InputMaybe<Array<AuthConnectionUiTypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AuthConnectionUiTypes_Enum>;
  _nin?: InputMaybe<Array<AuthConnectionUiTypes_Enum>>;
};

/** input type for inserting data into table "authConnectionUiTypes" */
export type AuthConnectionUiTypes_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** on_conflict condition type for table "authConnectionUiTypes" */
export type AuthConnectionUiTypes_On_Conflict = {
  constraint: AuthConnectionUiTypes_Constraint;
  update_columns?: Array<AuthConnectionUiTypes_Update_Column>;
  where?: InputMaybe<AuthConnectionUiTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "authConnectionUiTypes". */
export type AuthConnectionUiTypes_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: authConnectionUiTypes */
export type AuthConnectionUiTypes_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "authConnectionUiTypes" */
export type AuthConnectionUiTypes_Select_Column =
  /** column name */
  | 'id';

/** input type for updating data in table "authConnectionUiTypes" */
export type AuthConnectionUiTypes_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authConnectionUiTypes" */
export type AuthConnectionUiTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthConnectionUiTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthConnectionUiTypes_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "authConnectionUiTypes" */
export type AuthConnectionUiTypes_Update_Column =
  /** column name */
  | 'id';

export type AuthConnectionUiTypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthConnectionUiTypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthConnectionUiTypes_Bool_Exp;
};

/** Boolean expression to filter rows from the table "authConnections". All fields are combined with a logical 'AND'. */
export type AuthConnections_Bool_Exp = {
  _and?: InputMaybe<Array<AuthConnections_Bool_Exp>>;
  _not?: InputMaybe<AuthConnections_Bool_Exp>;
  _or?: InputMaybe<Array<AuthConnections_Bool_Exp>>;
  connectionType?: InputMaybe<AuthConnectionTypes_Enum_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  ssoConfigs?: InputMaybe<SsoConfig_Bool_Exp>;
  ssoConfigs_aggregate?: InputMaybe<SsoConfig_Aggregate_Bool_Exp>;
  uiType?: InputMaybe<AuthConnectionUiTypes_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "authConnections" */
export type AuthConnections_Constraint =
  /** unique or primary key constraint on columns "name" */
  | 'authConnections_name_key'
  /** unique or primary key constraint on columns "id" */
  | 'authConnections_pkey';

/** input type for inserting data into table "authConnections" */
export type AuthConnections_Insert_Input = {
  connectionType?: InputMaybe<AuthConnectionTypes_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ssoConfigs?: InputMaybe<SsoConfig_Arr_Rel_Insert_Input>;
  uiType?: InputMaybe<AuthConnectionUiTypes_Enum>;
};

/** input type for inserting object relation for remote table "authConnections" */
export type AuthConnections_Obj_Rel_Insert_Input = {
  data: AuthConnections_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthConnections_On_Conflict>;
};

/** on_conflict condition type for table "authConnections" */
export type AuthConnections_On_Conflict = {
  constraint: AuthConnections_Constraint;
  update_columns?: Array<AuthConnections_Update_Column>;
  where?: InputMaybe<AuthConnections_Bool_Exp>;
};

/** Ordering options when selecting data from "authConnections". */
export type AuthConnections_Order_By = {
  connectionType?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  ssoConfigs_aggregate?: InputMaybe<SsoConfig_Aggregate_Order_By>;
  uiType?: InputMaybe<Order_By>;
};

/** primary key columns input for table: authConnections */
export type AuthConnections_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "authConnections" */
export type AuthConnections_Select_Column =
  /** column name */
  | 'connectionType'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'uiType';

/** input type for updating data in table "authConnections" */
export type AuthConnections_Set_Input = {
  connectionType?: InputMaybe<AuthConnectionTypes_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uiType?: InputMaybe<AuthConnectionUiTypes_Enum>;
};

/** Streaming cursor of the table "authConnections" */
export type AuthConnections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthConnections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthConnections_Stream_Cursor_Value_Input = {
  connectionType?: InputMaybe<AuthConnectionTypes_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uiType?: InputMaybe<AuthConnectionUiTypes_Enum>;
};

/** update columns of table "authConnections" */
export type AuthConnections_Update_Column =
  /** column name */
  | 'connectionType'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'uiType';

export type AuthConnections_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthConnections_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthConnections_Bool_Exp;
};

/** ordering argument of a cursor */
export type Cursor_Ordering =
  /** ascending ordering of the cursor */
  | 'ASC'
  /** descending ordering of the cursor */
  | 'DESC';

/** Boolean expression to filter rows from the table "dataChangeStatuses". All fields are combined with a logical 'AND'. */
export type DataChangeStatuses_Bool_Exp = {
  _and?: InputMaybe<Array<DataChangeStatuses_Bool_Exp>>;
  _not?: InputMaybe<DataChangeStatuses_Bool_Exp>;
  _or?: InputMaybe<Array<DataChangeStatuses_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "dataChangeStatuses" */
export type DataChangeStatuses_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'dataChangeStatuses_pkey'
  /** unique or primary key constraint on columns "title" */
  | 'dataChangeStatuses_title_key';

export type DataChangeStatuses_Enum =
  /** Published */
  | 'PUBLISHED'
  /** Unpublished */
  | 'UNPUBLISHED';

/** Boolean expression to compare columns of type "dataChangeStatuses_enum". All fields are combined with logical 'AND'. */
export type DataChangeStatuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<DataChangeStatuses_Enum>;
  _in?: InputMaybe<Array<DataChangeStatuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<DataChangeStatuses_Enum>;
  _nin?: InputMaybe<Array<DataChangeStatuses_Enum>>;
};

/** input type for inserting data into table "dataChangeStatuses" */
export type DataChangeStatuses_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** on_conflict condition type for table "dataChangeStatuses" */
export type DataChangeStatuses_On_Conflict = {
  constraint: DataChangeStatuses_Constraint;
  update_columns?: Array<DataChangeStatuses_Update_Column>;
  where?: InputMaybe<DataChangeStatuses_Bool_Exp>;
};

/** Ordering options when selecting data from "dataChangeStatuses". */
export type DataChangeStatuses_Order_By = {
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dataChangeStatuses */
export type DataChangeStatuses_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "dataChangeStatuses" */
export type DataChangeStatuses_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

/** input type for updating data in table "dataChangeStatuses" */
export type DataChangeStatuses_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "dataChangeStatuses" */
export type DataChangeStatuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DataChangeStatuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DataChangeStatuses_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "dataChangeStatuses" */
export type DataChangeStatuses_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

export type DataChangeStatuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataChangeStatuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: DataChangeStatuses_Bool_Exp;
};

export type DataChanges_Aggregate_Bool_Exp = {
  count?: InputMaybe<DataChanges_Aggregate_Bool_Exp_Count>;
};

export type DataChanges_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<DataChanges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DataChanges_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** order by aggregate values of table "dataChanges" */
export type DataChanges_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<DataChanges_Max_Order_By>;
  min?: InputMaybe<DataChanges_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DataChanges_Append_Input = {
  inversePatches?: InputMaybe<Scalars['jsonb']['input']>;
  patches?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "dataChanges" */
export type DataChanges_Arr_Rel_Insert_Input = {
  data: Array<DataChanges_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<DataChanges_On_Conflict>;
};

/** Boolean expression to filter rows from the table "dataChanges". All fields are combined with a logical 'AND'. */
export type DataChanges_Bool_Exp = {
  _and?: InputMaybe<Array<DataChanges_Bool_Exp>>;
  _not?: InputMaybe<DataChanges_Bool_Exp>;
  _or?: InputMaybe<Array<DataChanges_Bool_Exp>>;
  date?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  instanceId?: InputMaybe<String_Comparison_Exp>;
  inversePatches?: InputMaybe<Jsonb_Comparison_Exp>;
  patches?: InputMaybe<Jsonb_Comparison_Exp>;
  siteInstance?: InputMaybe<SiteInstances_Bool_Exp>;
  statusId?: InputMaybe<DataChangeStatuses_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "dataChanges" */
export type DataChanges_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'dataChanges_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DataChanges_Delete_At_Path_Input = {
  inversePatches?: InputMaybe<Array<Scalars['String']['input']>>;
  patches?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DataChanges_Delete_Elem_Input = {
  inversePatches?: InputMaybe<Scalars['Int']['input']>;
  patches?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DataChanges_Delete_Key_Input = {
  inversePatches?: InputMaybe<Scalars['String']['input']>;
  patches?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "dataChanges" */
export type DataChanges_Insert_Input = {
  date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  inversePatches?: InputMaybe<Scalars['jsonb']['input']>;
  patches?: InputMaybe<Scalars['jsonb']['input']>;
  siteInstance?: InputMaybe<SiteInstances_Obj_Rel_Insert_Input>;
  statusId?: InputMaybe<DataChangeStatuses_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "dataChanges" */
export type DataChanges_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instanceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "dataChanges" */
export type DataChanges_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instanceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "dataChanges" */
export type DataChanges_Obj_Rel_Insert_Input = {
  data: DataChanges_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<DataChanges_On_Conflict>;
};

/** on_conflict condition type for table "dataChanges" */
export type DataChanges_On_Conflict = {
  constraint: DataChanges_Constraint;
  update_columns?: Array<DataChanges_Update_Column>;
  where?: InputMaybe<DataChanges_Bool_Exp>;
};

/** Ordering options when selecting data from "dataChanges". */
export type DataChanges_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instanceId?: InputMaybe<Order_By>;
  inversePatches?: InputMaybe<Order_By>;
  patches?: InputMaybe<Order_By>;
  siteInstance?: InputMaybe<SiteInstances_Order_By>;
  statusId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dataChanges */
export type DataChanges_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DataChanges_Prepend_Input = {
  inversePatches?: InputMaybe<Scalars['jsonb']['input']>;
  patches?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "dataChanges" */
export type DataChanges_Select_Column =
  /** column name */
  | 'date'
  /** column name */
  | 'id'
  /** column name */
  | 'instanceId'
  /** column name */
  | 'inversePatches'
  /** column name */
  | 'patches'
  /** column name */
  | 'statusId'
  /** column name */
  | 'userId';

/** input type for updating data in table "dataChanges" */
export type DataChanges_Set_Input = {
  date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  inversePatches?: InputMaybe<Scalars['jsonb']['input']>;
  patches?: InputMaybe<Scalars['jsonb']['input']>;
  statusId?: InputMaybe<DataChangeStatuses_Enum>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "dataChanges" */
export type DataChanges_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DataChanges_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DataChanges_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  inversePatches?: InputMaybe<Scalars['jsonb']['input']>;
  patches?: InputMaybe<Scalars['jsonb']['input']>;
  statusId?: InputMaybe<DataChangeStatuses_Enum>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "dataChanges" */
export type DataChanges_Update_Column =
  /** column name */
  | 'date'
  /** column name */
  | 'id'
  /** column name */
  | 'instanceId'
  /** column name */
  | 'inversePatches'
  /** column name */
  | 'patches'
  /** column name */
  | 'statusId'
  /** column name */
  | 'userId';

export type DataChanges_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DataChanges_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DataChanges_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DataChanges_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DataChanges_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DataChanges_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataChanges_Set_Input>;
  /** filter the rows which have to be updated */
  where: DataChanges_Bool_Exp;
};

/** Boolean expression to filter rows from the table "dataSets". All fields are combined with a logical 'AND'. */
export type DataSets_Bool_Exp = {
  _and?: InputMaybe<Array<DataSets_Bool_Exp>>;
  _not?: InputMaybe<DataSets_Bool_Exp>;
  _or?: InputMaybe<Array<DataSets_Bool_Exp>>;
  data?: InputMaybe<Json_Comparison_Exp>;
  dateCreated?: InputMaybe<Timestamptz_Comparison_Exp>;
  dateUpdated?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isWritable?: InputMaybe<Boolean_Comparison_Exp>;
  md5?: InputMaybe<String_Comparison_Exp>;
  siteInstance?: InputMaybe<SiteInstances_Bool_Exp>;
};

/** unique or primary key constraints on table "dataSets" */
export type DataSets_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'dataSets_pkey';

/** input type for inserting data into table "dataSets" */
export type DataSets_Insert_Input = {
  data?: InputMaybe<Scalars['json']['input']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  dateUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated */
  isWritable?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated */
  md5?: InputMaybe<Scalars['String']['input']>;
  siteInstance?: InputMaybe<SiteInstances_Obj_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "dataSets" */
export type DataSets_Obj_Rel_Insert_Input = {
  data: DataSets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<DataSets_On_Conflict>;
};

/** on_conflict condition type for table "dataSets" */
export type DataSets_On_Conflict = {
  constraint: DataSets_Constraint;
  update_columns?: Array<DataSets_Update_Column>;
  where?: InputMaybe<DataSets_Bool_Exp>;
};

/** Ordering options when selecting data from "dataSets". */
export type DataSets_Order_By = {
  data?: InputMaybe<Order_By>;
  dateCreated?: InputMaybe<Order_By>;
  dateUpdated?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isWritable?: InputMaybe<Order_By>;
  md5?: InputMaybe<Order_By>;
  siteInstance?: InputMaybe<SiteInstances_Order_By>;
};

/** primary key columns input for table: dataSets */
export type DataSets_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "dataSets" */
export type DataSets_Select_Column =
  /** column name */
  | 'data'
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'dateUpdated'
  /** column name */
  | 'id'
  /** column name */
  | 'isWritable'
  /** column name */
  | 'md5';

/** input type for updating data in table "dataSets" */
export type DataSets_Set_Input = {
  data?: InputMaybe<Scalars['json']['input']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  dateUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated */
  isWritable?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated */
  md5?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "dataSets" */
export type DataSets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DataSets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DataSets_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['json']['input']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  dateUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated */
  isWritable?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated */
  md5?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "dataSets" */
export type DataSets_Update_Column =
  /** column name */
  | 'data'
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'dateUpdated'
  /** column name */
  | 'id'
  /** column name */
  | 'isWritable'
  /** column name */
  | 'md5';

export type DataSets_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataSets_Set_Input>;
  /** filter the rows which have to be updated */
  where: DataSets_Bool_Exp;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** Boolean expression to filter rows from the table "designSourceFileFigma". All fields are combined with a logical 'AND'. */
export type DesignSourceFileFigma_Bool_Exp = {
  _and?: InputMaybe<Array<DesignSourceFileFigma_Bool_Exp>>;
  _not?: InputMaybe<DesignSourceFileFigma_Bool_Exp>;
  _or?: InputMaybe<Array<DesignSourceFileFigma_Bool_Exp>>;
  componentCount?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  dateImported?: InputMaybe<Timestamp_Comparison_Exp>;
  errorMessage?: InputMaybe<String_Comparison_Exp>;
  fileId?: InputMaybe<String_Comparison_Exp>;
  frameCount?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  pageCount?: InputMaybe<Int_Comparison_Exp>;
  site?: InputMaybe<Sites_Bool_Exp>;
  siteId?: InputMaybe<String_Comparison_Exp>;
  sourceUserId?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<DesignSourceFileStatus_Bool_Exp>;
  statusId?: InputMaybe<DesignSourceFileStatus_Enum_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
  variantCount?: InputMaybe<Int_Comparison_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "designSourceFileFigma" */
export type DesignSourceFileFigma_Constraint =
  /** unique or primary key constraint on columns "fileId", "version", "siteId" */
  | 'designSourceFileFigma_pkey';

/** input type for incrementing numeric columns in table "designSourceFileFigma" */
export type DesignSourceFileFigma_Inc_Input = {
  componentCount?: InputMaybe<Scalars['Int']['input']>;
  frameCount?: InputMaybe<Scalars['Int']['input']>;
  pageCount?: InputMaybe<Scalars['Int']['input']>;
  variantCount?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "designSourceFileFigma" */
export type DesignSourceFileFigma_Insert_Input = {
  componentCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  dateImported?: InputMaybe<Scalars['timestamp']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  frameCount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageCount?: InputMaybe<Scalars['Int']['input']>;
  site?: InputMaybe<Sites_Obj_Rel_Insert_Input>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  sourceUserId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DesignSourceFileStatus_Obj_Rel_Insert_Input>;
  statusId?: InputMaybe<DesignSourceFileStatus_Enum>;
  url?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']['input']>;
  variantCount?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** on_conflict condition type for table "designSourceFileFigma" */
export type DesignSourceFileFigma_On_Conflict = {
  constraint: DesignSourceFileFigma_Constraint;
  update_columns?: Array<DesignSourceFileFigma_Update_Column>;
  where?: InputMaybe<DesignSourceFileFigma_Bool_Exp>;
};

/** Ordering options when selecting data from "designSourceFileFigma". */
export type DesignSourceFileFigma_Order_By = {
  componentCount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dateImported?: InputMaybe<Order_By>;
  errorMessage?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  frameCount?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pageCount?: InputMaybe<Order_By>;
  site?: InputMaybe<Sites_Order_By>;
  siteId?: InputMaybe<Order_By>;
  sourceUserId?: InputMaybe<Order_By>;
  status?: InputMaybe<DesignSourceFileStatus_Order_By>;
  statusId?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
  variantCount?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: designSourceFileFigma */
export type DesignSourceFileFigma_Pk_Columns_Input = {
  fileId: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** select columns of table "designSourceFileFigma" */
export type DesignSourceFileFigma_Select_Column =
  /** column name */
  | 'componentCount'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dateImported'
  /** column name */
  | 'errorMessage'
  /** column name */
  | 'fileId'
  /** column name */
  | 'frameCount'
  /** column name */
  | 'name'
  /** column name */
  | 'pageCount'
  /** column name */
  | 'siteId'
  /** column name */
  | 'sourceUserId'
  /** column name */
  | 'statusId'
  /** column name */
  | 'url'
  /** column name */
  | 'userId'
  /** column name */
  | 'variantCount'
  /** column name */
  | 'version';

/** input type for updating data in table "designSourceFileFigma" */
export type DesignSourceFileFigma_Set_Input = {
  componentCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  dateImported?: InputMaybe<Scalars['timestamp']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  frameCount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageCount?: InputMaybe<Scalars['Int']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  sourceUserId?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<DesignSourceFileStatus_Enum>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  variantCount?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "designSourceFileFigma" */
export type DesignSourceFileFigma_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DesignSourceFileFigma_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DesignSourceFileFigma_Stream_Cursor_Value_Input = {
  componentCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  dateImported?: InputMaybe<Scalars['timestamp']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  frameCount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageCount?: InputMaybe<Scalars['Int']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  sourceUserId?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<DesignSourceFileStatus_Enum>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  variantCount?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "designSourceFileFigma" */
export type DesignSourceFileFigma_Update_Column =
  /** column name */
  | 'componentCount'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dateImported'
  /** column name */
  | 'errorMessage'
  /** column name */
  | 'fileId'
  /** column name */
  | 'frameCount'
  /** column name */
  | 'name'
  /** column name */
  | 'pageCount'
  /** column name */
  | 'siteId'
  /** column name */
  | 'sourceUserId'
  /** column name */
  | 'statusId'
  /** column name */
  | 'url'
  /** column name */
  | 'userId'
  /** column name */
  | 'variantCount'
  /** column name */
  | 'version';

export type DesignSourceFileFigma_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DesignSourceFileFigma_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DesignSourceFileFigma_Set_Input>;
  /** filter the rows which have to be updated */
  where: DesignSourceFileFigma_Bool_Exp;
};

/** Boolean expression to filter rows from the table "designSourceFileStatus". All fields are combined with a logical 'AND'. */
export type DesignSourceFileStatus_Bool_Exp = {
  _and?: InputMaybe<Array<DesignSourceFileStatus_Bool_Exp>>;
  _not?: InputMaybe<DesignSourceFileStatus_Bool_Exp>;
  _or?: InputMaybe<Array<DesignSourceFileStatus_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "designSourceFileStatus" */
export type DesignSourceFileStatus_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'designSourceFileStatus_pkey';

export type DesignSourceFileStatus_Enum =
  /** Done */
  | 'DONE'
  /** Error */
  | 'ERROR'
  /** New */
  | 'NEW'
  /** Processing */
  | 'PROCESSING'
  /** Processing File */
  | 'PROCESSING_FILE'
  /** Processing Image Cache */
  | 'PROCESSING_IMAGE_CACHE'
  /** Processing Temp URLs */
  | 'PROCESSING_TEMP_URLS';

/** Boolean expression to compare columns of type "designSourceFileStatus_enum". All fields are combined with logical 'AND'. */
export type DesignSourceFileStatus_Enum_Comparison_Exp = {
  _eq?: InputMaybe<DesignSourceFileStatus_Enum>;
  _in?: InputMaybe<Array<DesignSourceFileStatus_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<DesignSourceFileStatus_Enum>;
  _nin?: InputMaybe<Array<DesignSourceFileStatus_Enum>>;
};

/** input type for inserting data into table "designSourceFileStatus" */
export type DesignSourceFileStatus_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "designSourceFileStatus" */
export type DesignSourceFileStatus_Obj_Rel_Insert_Input = {
  data: DesignSourceFileStatus_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<DesignSourceFileStatus_On_Conflict>;
};

/** on_conflict condition type for table "designSourceFileStatus" */
export type DesignSourceFileStatus_On_Conflict = {
  constraint: DesignSourceFileStatus_Constraint;
  update_columns?: Array<DesignSourceFileStatus_Update_Column>;
  where?: InputMaybe<DesignSourceFileStatus_Bool_Exp>;
};

/** Ordering options when selecting data from "designSourceFileStatus". */
export type DesignSourceFileStatus_Order_By = {
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: designSourceFileStatus */
export type DesignSourceFileStatus_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "designSourceFileStatus" */
export type DesignSourceFileStatus_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

/** input type for updating data in table "designSourceFileStatus" */
export type DesignSourceFileStatus_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "designSourceFileStatus" */
export type DesignSourceFileStatus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DesignSourceFileStatus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DesignSourceFileStatus_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "designSourceFileStatus" */
export type DesignSourceFileStatus_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

export type DesignSourceFileStatus_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DesignSourceFileStatus_Set_Input>;
  /** filter the rows which have to be updated */
  where: DesignSourceFileStatus_Bool_Exp;
};

/** Boolean expression to filter rows from the table "gitProviders". All fields are combined with a logical 'AND'. */
export type GitProviders_Bool_Exp = {
  _and?: InputMaybe<Array<GitProviders_Bool_Exp>>;
  _not?: InputMaybe<GitProviders_Bool_Exp>;
  _or?: InputMaybe<Array<GitProviders_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "gitProviders" */
export type GitProviders_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'gitProviders_pkey'
  /** unique or primary key constraint on columns "title" */
  | 'gitProviders_title_key';

export type GitProviders_Enum =
  /** Azure */
  | 'azure'
  /** Bitbucket Cloud */
  | 'bitbucketCloud'
  /** Bitbucket Server */
  | 'bitbucketServer'
  /** GitHub */
  | 'gitHub'
  /** GitLab */
  | 'gitLab'
  /** GitLab Rest */
  | 'gitLabRest'
  /** None */
  | 'none';

/** Boolean expression to compare columns of type "gitProviders_enum". All fields are combined with logical 'AND'. */
export type GitProviders_Enum_Comparison_Exp = {
  _eq?: InputMaybe<GitProviders_Enum>;
  _in?: InputMaybe<Array<GitProviders_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<GitProviders_Enum>;
  _nin?: InputMaybe<Array<GitProviders_Enum>>;
};

/** input type for inserting data into table "gitProviders" */
export type GitProviders_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** on_conflict condition type for table "gitProviders" */
export type GitProviders_On_Conflict = {
  constraint: GitProviders_Constraint;
  update_columns?: Array<GitProviders_Update_Column>;
  where?: InputMaybe<GitProviders_Bool_Exp>;
};

/** Ordering options when selecting data from "gitProviders". */
export type GitProviders_Order_By = {
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gitProviders */
export type GitProviders_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "gitProviders" */
export type GitProviders_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

/** input type for updating data in table "gitProviders" */
export type GitProviders_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "gitProviders" */
export type GitProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: GitProviders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type GitProviders_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "gitProviders" */
export type GitProviders_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

export type GitProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GitProviders_Set_Input>;
  /** filter the rows which have to be updated */
  where: GitProviders_Bool_Exp;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** Boolean expression to filter rows from the table "oAuthSources". All fields are combined with a logical 'AND'. */
export type OAuthSources_Bool_Exp = {
  _and?: InputMaybe<Array<OAuthSources_Bool_Exp>>;
  _not?: InputMaybe<OAuthSources_Bool_Exp>;
  _or?: InputMaybe<Array<OAuthSources_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "oAuthSources" */
export type OAuthSources_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'oAuthSources_pkey';

export type OAuthSources_Enum =
  /** Figma */
  | 'FIGMA';

/** Boolean expression to compare columns of type "oAuthSources_enum". All fields are combined with logical 'AND'. */
export type OAuthSources_Enum_Comparison_Exp = {
  _eq?: InputMaybe<OAuthSources_Enum>;
  _in?: InputMaybe<Array<OAuthSources_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<OAuthSources_Enum>;
  _nin?: InputMaybe<Array<OAuthSources_Enum>>;
};

/** input type for inserting data into table "oAuthSources" */
export type OAuthSources_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "oAuthSources" */
export type OAuthSources_Obj_Rel_Insert_Input = {
  data: OAuthSources_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<OAuthSources_On_Conflict>;
};

/** on_conflict condition type for table "oAuthSources" */
export type OAuthSources_On_Conflict = {
  constraint: OAuthSources_Constraint;
  update_columns?: Array<OAuthSources_Update_Column>;
  where?: InputMaybe<OAuthSources_Bool_Exp>;
};

/** Ordering options when selecting data from "oAuthSources". */
export type OAuthSources_Order_By = {
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: oAuthSources */
export type OAuthSources_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "oAuthSources" */
export type OAuthSources_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

/** input type for updating data in table "oAuthSources" */
export type OAuthSources_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "oAuthSources" */
export type OAuthSources_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: OAuthSources_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type OAuthSources_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "oAuthSources" */
export type OAuthSources_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

export type OAuthSources_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OAuthSources_Set_Input>;
  /** filter the rows which have to be updated */
  where: OAuthSources_Bool_Exp;
};

/** Boolean expression to filter rows from the table "oAuthTokenStatuses". All fields are combined with a logical 'AND'. */
export type OAuthTokenStatuses_Bool_Exp = {
  _and?: InputMaybe<Array<OAuthTokenStatuses_Bool_Exp>>;
  _not?: InputMaybe<OAuthTokenStatuses_Bool_Exp>;
  _or?: InputMaybe<Array<OAuthTokenStatuses_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "oAuthTokenStatuses" */
export type OAuthTokenStatuses_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'oAuthTokenStatuses_pkey';

export type OAuthTokenStatuses_Enum =
  /** Failed */
  | 'FAILED'
  /** Success */
  | 'SUCCESS';

/** Boolean expression to compare columns of type "oAuthTokenStatuses_enum". All fields are combined with logical 'AND'. */
export type OAuthTokenStatuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<OAuthTokenStatuses_Enum>;
  _in?: InputMaybe<Array<OAuthTokenStatuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<OAuthTokenStatuses_Enum>;
  _nin?: InputMaybe<Array<OAuthTokenStatuses_Enum>>;
};

/** input type for inserting data into table "oAuthTokenStatuses" */
export type OAuthTokenStatuses_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "oAuthTokenStatuses" */
export type OAuthTokenStatuses_Obj_Rel_Insert_Input = {
  data: OAuthTokenStatuses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<OAuthTokenStatuses_On_Conflict>;
};

/** on_conflict condition type for table "oAuthTokenStatuses" */
export type OAuthTokenStatuses_On_Conflict = {
  constraint: OAuthTokenStatuses_Constraint;
  update_columns?: Array<OAuthTokenStatuses_Update_Column>;
  where?: InputMaybe<OAuthTokenStatuses_Bool_Exp>;
};

/** Ordering options when selecting data from "oAuthTokenStatuses". */
export type OAuthTokenStatuses_Order_By = {
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: oAuthTokenStatuses */
export type OAuthTokenStatuses_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "oAuthTokenStatuses" */
export type OAuthTokenStatuses_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

/** input type for updating data in table "oAuthTokenStatuses" */
export type OAuthTokenStatuses_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "oAuthTokenStatuses" */
export type OAuthTokenStatuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: OAuthTokenStatuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type OAuthTokenStatuses_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "oAuthTokenStatuses" */
export type OAuthTokenStatuses_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

export type OAuthTokenStatuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OAuthTokenStatuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: OAuthTokenStatuses_Bool_Exp;
};

/** column ordering options */
export type Order_By =
  /** in ascending order, nulls last */
  | 'asc'
  /** in ascending order, nulls first */
  | 'asc_nulls_first'
  /** in ascending order, nulls last */
  | 'asc_nulls_last'
  /** in descending order, nulls first */
  | 'desc'
  /** in descending order, nulls first */
  | 'desc_nulls_first'
  /** in descending order, nulls last */
  | 'desc_nulls_last';

/** Boolean expression to filter rows from the table "orgs". All fields are combined with a logical 'AND'. */
export type Orgs_Bool_Exp = {
  _and?: InputMaybe<Array<Orgs_Bool_Exp>>;
  _not?: InputMaybe<Orgs_Bool_Exp>;
  _or?: InputMaybe<Array<Orgs_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  sites?: InputMaybe<Sites_Bool_Exp>;
  sites_aggregate?: InputMaybe<Sites_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "orgs" */
export type Orgs_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'orgs_pkey';

/** input type for inserting data into table "orgs" */
export type Orgs_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  sites?: InputMaybe<Sites_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "orgs" */
export type Orgs_Obj_Rel_Insert_Input = {
  data: Orgs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Orgs_On_Conflict>;
};

/** on_conflict condition type for table "orgs" */
export type Orgs_On_Conflict = {
  constraint: Orgs_Constraint;
  update_columns?: Array<Orgs_Update_Column>;
  where?: InputMaybe<Orgs_Bool_Exp>;
};

/** Ordering options when selecting data from "orgs". */
export type Orgs_Order_By = {
  id?: InputMaybe<Order_By>;
  sites_aggregate?: InputMaybe<Sites_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: orgs */
export type Orgs_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "orgs" */
export type Orgs_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

/** input type for updating data in table "orgs" */
export type Orgs_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "orgs" */
export type Orgs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Orgs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Orgs_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "orgs" */
export type Orgs_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

export type Orgs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Orgs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Orgs_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Payments_Append_Input = {
  details?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "payments". All fields are combined with a logical 'AND'. */
export type Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Payments_Bool_Exp>>;
  _not?: InputMaybe<Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Payments_Bool_Exp>>;
  dateCreated?: InputMaybe<Timestamptz_Comparison_Exp>;
  details?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  site?: InputMaybe<Sites_Bool_Exp>;
  siteId?: InputMaybe<String_Comparison_Exp>;
  transactionId?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "payments" */
export type Payments_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'payments_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Payments_Delete_At_Path_Input = {
  details?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Payments_Delete_Elem_Input = {
  details?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Payments_Delete_Key_Input = {
  details?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "payments" */
export type Payments_Insert_Input = {
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  details?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  site?: InputMaybe<Sites_Obj_Rel_Insert_Input>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** on_conflict condition type for table "payments" */
export type Payments_On_Conflict = {
  constraint: Payments_Constraint;
  update_columns?: Array<Payments_Update_Column>;
  where?: InputMaybe<Payments_Bool_Exp>;
};

/** Ordering options when selecting data from "payments". */
export type Payments_Order_By = {
  dateCreated?: InputMaybe<Order_By>;
  details?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  site?: InputMaybe<Sites_Order_By>;
  siteId?: InputMaybe<Order_By>;
  transactionId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payments */
export type Payments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Payments_Prepend_Input = {
  details?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "payments" */
export type Payments_Select_Column =
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'details'
  /** column name */
  | 'id'
  /** column name */
  | 'siteId'
  /** column name */
  | 'transactionId'
  /** column name */
  | 'userId';

/** input type for updating data in table "payments" */
export type Payments_Set_Input = {
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  details?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "payments" */
export type Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payments_Stream_Cursor_Value_Input = {
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  details?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "payments" */
export type Payments_Update_Column =
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'details'
  /** column name */
  | 'id'
  /** column name */
  | 'siteId'
  /** column name */
  | 'transactionId'
  /** column name */
  | 'userId';

export type Payments_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Payments_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Payments_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Payments_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Payments_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Payments_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payments_Bool_Exp;
};

/** Boolean expression to filter rows from the table "plans". All fields are combined with a logical 'AND'. */
export type Plans_Bool_Exp = {
  _and?: InputMaybe<Array<Plans_Bool_Exp>>;
  _not?: InputMaybe<Plans_Bool_Exp>;
  _or?: InputMaybe<Array<Plans_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "plans" */
export type Plans_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'plans_pkey';

export type Plans_Enum =
  /** 20 */
  | 'L20'
  /** 40 */
  | 'L40';

/** Boolean expression to compare columns of type "plans_enum". All fields are combined with logical 'AND'. */
export type Plans_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Plans_Enum>;
  _in?: InputMaybe<Array<Plans_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Plans_Enum>;
  _nin?: InputMaybe<Array<Plans_Enum>>;
};

/** input type for inserting data into table "plans" */
export type Plans_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "plans" */
export type Plans_Obj_Rel_Insert_Input = {
  data: Plans_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Plans_On_Conflict>;
};

/** on_conflict condition type for table "plans" */
export type Plans_On_Conflict = {
  constraint: Plans_Constraint;
  update_columns?: Array<Plans_Update_Column>;
  where?: InputMaybe<Plans_Bool_Exp>;
};

/** Ordering options when selecting data from "plans". */
export type Plans_Order_By = {
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: plans */
export type Plans_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "plans" */
export type Plans_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

/** input type for updating data in table "plans" */
export type Plans_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "plans" */
export type Plans_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Plans_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Plans_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "plans" */
export type Plans_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

export type Plans_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Plans_Set_Input>;
  /** filter the rows which have to be updated */
  where: Plans_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RenderData_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "renderData". All fields are combined with a logical 'AND'. */
export type RenderData_Bool_Exp = {
  _and?: InputMaybe<Array<RenderData_Bool_Exp>>;
  _not?: InputMaybe<RenderData_Bool_Exp>;
  _or?: InputMaybe<Array<RenderData_Bool_Exp>>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  dateCreated?: InputMaybe<Timestamp_Comparison_Exp>;
  dateLastAccessed?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "renderData" */
export type RenderData_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'renderData_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RenderData_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RenderData_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RenderData_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "renderData" */
export type RenderData_Insert_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  dateCreated?: InputMaybe<Scalars['timestamp']['input']>;
  dateLastAccessed?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** on_conflict condition type for table "renderData" */
export type RenderData_On_Conflict = {
  constraint: RenderData_Constraint;
  update_columns?: Array<RenderData_Update_Column>;
  where?: InputMaybe<RenderData_Bool_Exp>;
};

/** Ordering options when selecting data from "renderData". */
export type RenderData_Order_By = {
  data?: InputMaybe<Order_By>;
  dateCreated?: InputMaybe<Order_By>;
  dateLastAccessed?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: renderData */
export type RenderData_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RenderData_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "renderData" */
export type RenderData_Select_Column =
  /** column name */
  | 'data'
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'dateLastAccessed'
  /** column name */
  | 'id';

/** input type for updating data in table "renderData" */
export type RenderData_Set_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  dateCreated?: InputMaybe<Scalars['timestamp']['input']>;
  dateLastAccessed?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "renderData" */
export type RenderData_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RenderData_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RenderData_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  dateCreated?: InputMaybe<Scalars['timestamp']['input']>;
  dateLastAccessed?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "renderData" */
export type RenderData_Update_Column =
  /** column name */
  | 'data'
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'dateLastAccessed'
  /** column name */
  | 'id';

export type RenderData_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RenderData_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RenderData_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RenderData_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RenderData_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RenderData_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RenderData_Set_Input>;
  /** filter the rows which have to be updated */
  where: RenderData_Bool_Exp;
};

/** Boolean expression to filter rows from the table "responsibilities". All fields are combined with a logical 'AND'. */
export type Responsibilities_Bool_Exp = {
  _and?: InputMaybe<Array<Responsibilities_Bool_Exp>>;
  _not?: InputMaybe<Responsibilities_Bool_Exp>;
  _or?: InputMaybe<Array<Responsibilities_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "responsibilities" */
export type Responsibilities_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'responsibilities_pkey';

export type Responsibilities_Enum =
  /** Designer */
  | 'DESIGNER'
  /** Engineer */
  | 'ENGINEER'
  /** Marketing */
  | 'MARKETING'
  /** Other */
  | 'OTHER'
  /** Product */
  | 'PRODUCT';

/** Boolean expression to compare columns of type "responsibilities_enum". All fields are combined with logical 'AND'. */
export type Responsibilities_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Responsibilities_Enum>;
  _in?: InputMaybe<Array<Responsibilities_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Responsibilities_Enum>;
  _nin?: InputMaybe<Array<Responsibilities_Enum>>;
};

/** input type for inserting data into table "responsibilities" */
export type Responsibilities_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "responsibilities" */
export type Responsibilities_Obj_Rel_Insert_Input = {
  data: Responsibilities_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Responsibilities_On_Conflict>;
};

/** on_conflict condition type for table "responsibilities" */
export type Responsibilities_On_Conflict = {
  constraint: Responsibilities_Constraint;
  update_columns?: Array<Responsibilities_Update_Column>;
  where?: InputMaybe<Responsibilities_Bool_Exp>;
};

/** Ordering options when selecting data from "responsibilities". */
export type Responsibilities_Order_By = {
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: responsibilities */
export type Responsibilities_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "responsibilities" */
export type Responsibilities_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

/** input type for updating data in table "responsibilities" */
export type Responsibilities_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "responsibilities" */
export type Responsibilities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Responsibilities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Responsibilities_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "responsibilities" */
export type Responsibilities_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

export type Responsibilities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Responsibilities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Responsibilities_Bool_Exp;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Roles_Bool_Exp>>;
  _not?: InputMaybe<Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Roles_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  sitesUsers?: InputMaybe<SitesUsers_Bool_Exp>;
  sitesUsers_aggregate?: InputMaybe<SitesUsers_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "roles" */
export type Roles_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'roles_pkey'
  /** unique or primary key constraint on columns "title" */
  | 'roles_title_key';

export type Roles_Enum =
  /** Admin */
  | 'ADMIN'
  /** Anonymous */
  | 'ANONYMOUS'
  /** Consumer */
  | 'CONSUMER'
  /** Contributor */
  | 'CONTRIBUTOR'
  /** Editor */
  | 'EDITOR'
  /** Manager */
  | 'MANAGER'
  /** Viewer */
  | 'VIEWER';

/** Boolean expression to compare columns of type "roles_enum". All fields are combined with logical 'AND'. */
export type Roles_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Roles_Enum>;
  _in?: InputMaybe<Array<Roles_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Roles_Enum>;
  _nin?: InputMaybe<Array<Roles_Enum>>;
};

/** input type for inserting data into table "roles" */
export type Roles_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  sitesUsers?: InputMaybe<SitesUsers_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "roles" */
export type Roles_Obj_Rel_Insert_Input = {
  data: Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};

/** on_conflict condition type for table "roles" */
export type Roles_On_Conflict = {
  constraint: Roles_Constraint;
  update_columns?: Array<Roles_Update_Column>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "roles". */
export type Roles_Order_By = {
  id?: InputMaybe<Order_By>;
  sitesUsers_aggregate?: InputMaybe<SitesUsers_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roles */
export type Roles_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "roles" */
export type Roles_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

/** input type for updating data in table "roles" */
export type Roles_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "roles" */
export type Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Roles_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "roles" */
export type Roles_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

export type Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Roles_Bool_Exp;
};

export type SiteDeployments_Aggregate_Bool_Exp = {
  count?: InputMaybe<SiteDeployments_Aggregate_Bool_Exp_Count>;
};

export type SiteDeployments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<SiteDeployments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SiteDeployments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** order by aggregate values of table "siteDeployments" */
export type SiteDeployments_Aggregate_Order_By = {
  avg?: InputMaybe<SiteDeployments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SiteDeployments_Max_Order_By>;
  min?: InputMaybe<SiteDeployments_Min_Order_By>;
  stddev?: InputMaybe<SiteDeployments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<SiteDeployments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<SiteDeployments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<SiteDeployments_Sum_Order_By>;
  var_pop?: InputMaybe<SiteDeployments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<SiteDeployments_Var_Samp_Order_By>;
  variance?: InputMaybe<SiteDeployments_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SiteDeployments_Append_Input = {
  appClientDataNoMeta?: InputMaybe<Scalars['jsonb']['input']>;
  /** The appClientData.metaState object - which is tied to the specific deployment */
  metaState?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "siteDeployments" */
export type SiteDeployments_Arr_Rel_Insert_Input = {
  data: Array<SiteDeployments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SiteDeployments_On_Conflict>;
};

/** order by avg() on columns of table "siteDeployments" */
export type SiteDeployments_Avg_Order_By = {
  prNumber?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "siteDeployments". All fields are combined with a logical 'AND'. */
export type SiteDeployments_Bool_Exp = {
  _and?: InputMaybe<Array<SiteDeployments_Bool_Exp>>;
  _not?: InputMaybe<SiteDeployments_Bool_Exp>;
  _or?: InputMaybe<Array<SiteDeployments_Bool_Exp>>;
  appClientDataNoMeta?: InputMaybe<Jsonb_Comparison_Exp>;
  dateCreated?: InputMaybe<Timestamptz_Comparison_Exp>;
  dateUpdated?: InputMaybe<Timestamptz_Comparison_Exp>;
  gitBranch?: InputMaybe<String_Comparison_Exp>;
  gitSha?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metaState?: InputMaybe<Jsonb_Comparison_Exp>;
  prNumber?: InputMaybe<Int_Comparison_Exp>;
  prUrl?: InputMaybe<String_Comparison_Exp>;
  site?: InputMaybe<Sites_Bool_Exp>;
  siteId?: InputMaybe<String_Comparison_Exp>;
  siteInstances?: InputMaybe<SiteInstances_Bool_Exp>;
  siteInstances_aggregate?: InputMaybe<SiteInstances_Aggregate_Bool_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "siteDeployments" */
export type SiteDeployments_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'siteDeployments_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'siteDeployments_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SiteDeployments_Delete_At_Path_Input = {
  appClientDataNoMeta?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The appClientData.metaState object - which is tied to the specific deployment */
  metaState?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SiteDeployments_Delete_Elem_Input = {
  appClientDataNoMeta?: InputMaybe<Scalars['Int']['input']>;
  /** The appClientData.metaState object - which is tied to the specific deployment */
  metaState?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SiteDeployments_Delete_Key_Input = {
  appClientDataNoMeta?: InputMaybe<Scalars['String']['input']>;
  /** The appClientData.metaState object - which is tied to the specific deployment */
  metaState?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "siteDeployments" */
export type SiteDeployments_Inc_Input = {
  prNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "siteDeployments" */
export type SiteDeployments_Insert_Input = {
  appClientDataNoMeta?: InputMaybe<Scalars['jsonb']['input']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  dateUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  gitBranch?: InputMaybe<Scalars['String']['input']>;
  gitSha?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** The appClientData.metaState object - which is tied to the specific deployment */
  metaState?: InputMaybe<Scalars['jsonb']['input']>;
  prNumber?: InputMaybe<Scalars['Int']['input']>;
  prUrl?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Sites_Obj_Rel_Insert_Input>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  siteInstances?: InputMaybe<SiteInstances_Arr_Rel_Insert_Input>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "siteDeployments" */
export type SiteDeployments_Max_Order_By = {
  dateCreated?: InputMaybe<Order_By>;
  dateUpdated?: InputMaybe<Order_By>;
  gitBranch?: InputMaybe<Order_By>;
  gitSha?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prNumber?: InputMaybe<Order_By>;
  prUrl?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "siteDeployments" */
export type SiteDeployments_Min_Order_By = {
  dateCreated?: InputMaybe<Order_By>;
  dateUpdated?: InputMaybe<Order_By>;
  gitBranch?: InputMaybe<Order_By>;
  gitSha?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prNumber?: InputMaybe<Order_By>;
  prUrl?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "siteDeployments" */
export type SiteDeployments_Obj_Rel_Insert_Input = {
  data: SiteDeployments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<SiteDeployments_On_Conflict>;
};

/** on_conflict condition type for table "siteDeployments" */
export type SiteDeployments_On_Conflict = {
  constraint: SiteDeployments_Constraint;
  update_columns?: Array<SiteDeployments_Update_Column>;
  where?: InputMaybe<SiteDeployments_Bool_Exp>;
};

/** Ordering options when selecting data from "siteDeployments". */
export type SiteDeployments_Order_By = {
  appClientDataNoMeta?: InputMaybe<Order_By>;
  dateCreated?: InputMaybe<Order_By>;
  dateUpdated?: InputMaybe<Order_By>;
  gitBranch?: InputMaybe<Order_By>;
  gitSha?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metaState?: InputMaybe<Order_By>;
  prNumber?: InputMaybe<Order_By>;
  prUrl?: InputMaybe<Order_By>;
  site?: InputMaybe<Sites_Order_By>;
  siteId?: InputMaybe<Order_By>;
  siteInstances_aggregate?: InputMaybe<SiteInstances_Aggregate_Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: siteDeployments */
export type SiteDeployments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SiteDeployments_Prepend_Input = {
  appClientDataNoMeta?: InputMaybe<Scalars['jsonb']['input']>;
  /** The appClientData.metaState object - which is tied to the specific deployment */
  metaState?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "siteDeployments" */
export type SiteDeployments_Select_Column =
  /** column name */
  | 'appClientDataNoMeta'
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'dateUpdated'
  /** column name */
  | 'gitBranch'
  /** column name */
  | 'gitSha'
  /** column name */
  | 'id'
  /** column name */
  | 'metaState'
  /** column name */
  | 'prNumber'
  /** column name */
  | 'prUrl'
  /** column name */
  | 'siteId'
  /** column name */
  | 'url';

/** input type for updating data in table "siteDeployments" */
export type SiteDeployments_Set_Input = {
  appClientDataNoMeta?: InputMaybe<Scalars['jsonb']['input']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  dateUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  gitBranch?: InputMaybe<Scalars['String']['input']>;
  gitSha?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** The appClientData.metaState object - which is tied to the specific deployment */
  metaState?: InputMaybe<Scalars['jsonb']['input']>;
  prNumber?: InputMaybe<Scalars['Int']['input']>;
  prUrl?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "siteDeployments" */
export type SiteDeployments_Stddev_Order_By = {
  prNumber?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "siteDeployments" */
export type SiteDeployments_Stddev_Pop_Order_By = {
  prNumber?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "siteDeployments" */
export type SiteDeployments_Stddev_Samp_Order_By = {
  prNumber?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "siteDeployments" */
export type SiteDeployments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SiteDeployments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SiteDeployments_Stream_Cursor_Value_Input = {
  appClientDataNoMeta?: InputMaybe<Scalars['jsonb']['input']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  dateUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  gitBranch?: InputMaybe<Scalars['String']['input']>;
  gitSha?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** The appClientData.metaState object - which is tied to the specific deployment */
  metaState?: InputMaybe<Scalars['jsonb']['input']>;
  prNumber?: InputMaybe<Scalars['Int']['input']>;
  prUrl?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "siteDeployments" */
export type SiteDeployments_Sum_Order_By = {
  prNumber?: InputMaybe<Order_By>;
};

/** update columns of table "siteDeployments" */
export type SiteDeployments_Update_Column =
  /** column name */
  | 'appClientDataNoMeta'
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'dateUpdated'
  /** column name */
  | 'gitBranch'
  /** column name */
  | 'gitSha'
  /** column name */
  | 'id'
  /** column name */
  | 'metaState'
  /** column name */
  | 'prNumber'
  /** column name */
  | 'prUrl'
  /** column name */
  | 'siteId'
  /** column name */
  | 'url';

export type SiteDeployments_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SiteDeployments_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SiteDeployments_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SiteDeployments_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SiteDeployments_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SiteDeployments_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SiteDeployments_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SiteDeployments_Set_Input>;
  /** filter the rows which have to be updated */
  where: SiteDeployments_Bool_Exp;
};

/** order by var_pop() on columns of table "siteDeployments" */
export type SiteDeployments_Var_Pop_Order_By = {
  prNumber?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "siteDeployments" */
export type SiteDeployments_Var_Samp_Order_By = {
  prNumber?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "siteDeployments" */
export type SiteDeployments_Variance_Order_By = {
  prNumber?: InputMaybe<Order_By>;
};

export type SiteInstanceHistories_Aggregate_Bool_Exp = {
  count?: InputMaybe<SiteInstanceHistories_Aggregate_Bool_Exp_Count>;
};

export type SiteInstanceHistories_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<SiteInstanceHistories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SiteInstanceHistories_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** order by aggregate values of table "siteInstanceHistories" */
export type SiteInstanceHistories_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SiteInstanceHistories_Max_Order_By>;
  min?: InputMaybe<SiteInstanceHistories_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SiteInstanceHistories_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "siteInstanceHistories" */
export type SiteInstanceHistories_Arr_Rel_Insert_Input = {
  data: Array<SiteInstanceHistories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SiteInstanceHistories_On_Conflict>;
};

/** Boolean expression to filter rows from the table "siteInstanceHistories". All fields are combined with a logical 'AND'. */
export type SiteInstanceHistories_Bool_Exp = {
  _and?: InputMaybe<Array<SiteInstanceHistories_Bool_Exp>>;
  _not?: InputMaybe<SiteInstanceHistories_Bool_Exp>;
  _or?: InputMaybe<Array<SiteInstanceHistories_Bool_Exp>>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  instanceId?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  siteInstance?: InputMaybe<SiteInstances_Bool_Exp>;
  siteInstanceStatus?: InputMaybe<SiteInstanceStatuses_Bool_Exp>;
  statusId?: InputMaybe<SiteInstanceStatuses_Enum_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "siteInstanceHistories" */
export type SiteInstanceHistories_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'siteInstanceHistories_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SiteInstanceHistories_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SiteInstanceHistories_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SiteInstanceHistories_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "siteInstanceHistories" */
export type SiteInstanceHistories_Insert_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  siteInstance?: InputMaybe<SiteInstances_Obj_Rel_Insert_Input>;
  siteInstanceStatus?: InputMaybe<SiteInstanceStatuses_Obj_Rel_Insert_Input>;
  statusId?: InputMaybe<SiteInstanceStatuses_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "siteInstanceHistories" */
export type SiteInstanceHistories_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instanceId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "siteInstanceHistories" */
export type SiteInstanceHistories_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instanceId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "siteInstanceHistories" */
export type SiteInstanceHistories_On_Conflict = {
  constraint: SiteInstanceHistories_Constraint;
  update_columns?: Array<SiteInstanceHistories_Update_Column>;
  where?: InputMaybe<SiteInstanceHistories_Bool_Exp>;
};

/** Ordering options when selecting data from "siteInstanceHistories". */
export type SiteInstanceHistories_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instanceId?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  siteInstance?: InputMaybe<SiteInstances_Order_By>;
  siteInstanceStatus?: InputMaybe<SiteInstanceStatuses_Order_By>;
  statusId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: siteInstanceHistories */
export type SiteInstanceHistories_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SiteInstanceHistories_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "siteInstanceHistories" */
export type SiteInstanceHistories_Select_Column =
  /** column name */
  | 'date'
  /** column name */
  | 'id'
  /** column name */
  | 'instanceId'
  /** column name */
  | 'metadata'
  /** column name */
  | 'statusId'
  /** column name */
  | 'title'
  /** column name */
  | 'userId';

/** input type for updating data in table "siteInstanceHistories" */
export type SiteInstanceHistories_Set_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  statusId?: InputMaybe<SiteInstanceStatuses_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "siteInstanceHistories" */
export type SiteInstanceHistories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SiteInstanceHistories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SiteInstanceHistories_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  statusId?: InputMaybe<SiteInstanceStatuses_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "siteInstanceHistories" */
export type SiteInstanceHistories_Update_Column =
  /** column name */
  | 'date'
  /** column name */
  | 'id'
  /** column name */
  | 'instanceId'
  /** column name */
  | 'metadata'
  /** column name */
  | 'statusId'
  /** column name */
  | 'title'
  /** column name */
  | 'userId';

export type SiteInstanceHistories_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SiteInstanceHistories_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SiteInstanceHistories_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SiteInstanceHistories_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SiteInstanceHistories_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SiteInstanceHistories_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SiteInstanceHistories_Set_Input>;
  /** filter the rows which have to be updated */
  where: SiteInstanceHistories_Bool_Exp;
};

/** Boolean expression to filter rows from the table "siteInstanceStatuses". All fields are combined with a logical 'AND'. */
export type SiteInstanceStatuses_Bool_Exp = {
  _and?: InputMaybe<Array<SiteInstanceStatuses_Bool_Exp>>;
  _not?: InputMaybe<SiteInstanceStatuses_Bool_Exp>;
  _or?: InputMaybe<Array<SiteInstanceStatuses_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "siteInstanceStatuses" */
export type SiteInstanceStatuses_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'siteInstanceStatus_pkey'
  /** unique or primary key constraint on columns "title" */
  | 'siteInstanceStatus_title_key';

export type SiteInstanceStatuses_Enum =
  /** Deleted */
  | 'DELETED'
  /** Draft */
  | 'DRAFT'
  /** Proposed */
  | 'PROPOSED'
  /** Proposing */
  | 'PROPOSING'
  /** Published */
  | 'PUBLISHED'
  /** Publishing */
  | 'PUBLISHING';

/** Boolean expression to compare columns of type "siteInstanceStatuses_enum". All fields are combined with logical 'AND'. */
export type SiteInstanceStatuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<SiteInstanceStatuses_Enum>;
  _in?: InputMaybe<Array<SiteInstanceStatuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<SiteInstanceStatuses_Enum>;
  _nin?: InputMaybe<Array<SiteInstanceStatuses_Enum>>;
};

/** input type for inserting data into table "siteInstanceStatuses" */
export type SiteInstanceStatuses_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "siteInstanceStatuses" */
export type SiteInstanceStatuses_Obj_Rel_Insert_Input = {
  data: SiteInstanceStatuses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<SiteInstanceStatuses_On_Conflict>;
};

/** on_conflict condition type for table "siteInstanceStatuses" */
export type SiteInstanceStatuses_On_Conflict = {
  constraint: SiteInstanceStatuses_Constraint;
  update_columns?: Array<SiteInstanceStatuses_Update_Column>;
  where?: InputMaybe<SiteInstanceStatuses_Bool_Exp>;
};

/** Ordering options when selecting data from "siteInstanceStatuses". */
export type SiteInstanceStatuses_Order_By = {
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: siteInstanceStatuses */
export type SiteInstanceStatuses_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "siteInstanceStatuses" */
export type SiteInstanceStatuses_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

/** input type for updating data in table "siteInstanceStatuses" */
export type SiteInstanceStatuses_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "siteInstanceStatuses" */
export type SiteInstanceStatuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SiteInstanceStatuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SiteInstanceStatuses_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "siteInstanceStatuses" */
export type SiteInstanceStatuses_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

export type SiteInstanceStatuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SiteInstanceStatuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: SiteInstanceStatuses_Bool_Exp;
};

export type SiteInstances_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<SiteInstances_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<SiteInstances_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<SiteInstances_Aggregate_Bool_Exp_Count>;
};

export type SiteInstances_Aggregate_Bool_Exp_Bool_And = {
  arguments: SiteInstances_Select_Column_SiteInstances_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SiteInstances_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type SiteInstances_Aggregate_Bool_Exp_Bool_Or = {
  arguments: SiteInstances_Select_Column_SiteInstances_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SiteInstances_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type SiteInstances_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<SiteInstances_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SiteInstances_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** order by aggregate values of table "siteInstances" */
export type SiteInstances_Aggregate_Order_By = {
  avg?: InputMaybe<SiteInstances_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SiteInstances_Max_Order_By>;
  min?: InputMaybe<SiteInstances_Min_Order_By>;
  stddev?: InputMaybe<SiteInstances_Stddev_Order_By>;
  stddev_pop?: InputMaybe<SiteInstances_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<SiteInstances_Stddev_Samp_Order_By>;
  sum?: InputMaybe<SiteInstances_Sum_Order_By>;
  var_pop?: InputMaybe<SiteInstances_Var_Pop_Order_By>;
  var_samp?: InputMaybe<SiteInstances_Var_Samp_Order_By>;
  variance?: InputMaybe<SiteInstances_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "siteInstances" */
export type SiteInstances_Arr_Rel_Insert_Input = {
  data: Array<SiteInstances_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SiteInstances_On_Conflict>;
};

/** order by avg() on columns of table "siteInstances" */
export type SiteInstances_Avg_Order_By = {
  appClientDataMajorVersion?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "siteInstances". All fields are combined with a logical 'AND'. */
export type SiteInstances_Bool_Exp = {
  _and?: InputMaybe<Array<SiteInstances_Bool_Exp>>;
  _not?: InputMaybe<SiteInstances_Bool_Exp>;
  _or?: InputMaybe<Array<SiteInstances_Bool_Exp>>;
  appClientDataMajorVersion?: InputMaybe<Int_Comparison_Exp>;
  appState?: InputMaybe<DataSets_Bool_Exp>;
  appStateDataSetId?: InputMaybe<String_Comparison_Exp>;
  author?: InputMaybe<Users_Bool_Exp>;
  authorId?: InputMaybe<String_Comparison_Exp>;
  dataChanges?: InputMaybe<DataChanges_Bool_Exp>;
  dataChanges_aggregate?: InputMaybe<DataChanges_Aggregate_Bool_Exp>;
  dateCreated?: InputMaybe<Timestamptz_Comparison_Exp>;
  dateUpdated?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  gitBranch?: InputMaybe<String_Comparison_Exp>;
  histories?: InputMaybe<SiteInstanceHistories_Bool_Exp>;
  histories_aggregate?: InputMaybe<SiteInstanceHistories_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  lastCommittedDataChange?: InputMaybe<DataChanges_Bool_Exp>;
  lastCommittedDataChangeId?: InputMaybe<Uuid_Comparison_Exp>;
  preventGitWebhookDelete?: InputMaybe<Boolean_Comparison_Exp>;
  site?: InputMaybe<Sites_Bool_Exp>;
  siteById?: InputMaybe<Sites_Bool_Exp>;
  siteDeployment?: InputMaybe<SiteDeployments_Bool_Exp>;
  siteDeploymentId?: InputMaybe<Uuid_Comparison_Exp>;
  siteId?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<SiteInstanceStatuses_Bool_Exp>;
  statusId?: InputMaybe<SiteInstanceStatuses_Enum_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "siteInstances" */
export type SiteInstances_Constraint =
  /** unique or primary key constraint on columns "appStateDataSetId" */
  | 'siteInstances_appStateDataSetId_key'
  /** unique or primary key constraint on columns "id" */
  | 'siteInstances_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'siteInstances_pkey';

/** input type for incrementing numeric columns in table "siteInstances" */
export type SiteInstances_Inc_Input = {
  appClientDataMajorVersion?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "siteInstances" */
export type SiteInstances_Insert_Input = {
  appClientDataMajorVersion?: InputMaybe<Scalars['Int']['input']>;
  appState?: InputMaybe<DataSets_Obj_Rel_Insert_Input>;
  appStateDataSetId?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  dataChanges?: InputMaybe<DataChanges_Arr_Rel_Insert_Input>;
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  dateUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gitBranch?: InputMaybe<Scalars['String']['input']>;
  histories?: InputMaybe<SiteInstanceHistories_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCommittedDataChange?: InputMaybe<DataChanges_Obj_Rel_Insert_Input>;
  lastCommittedDataChangeId?: InputMaybe<Scalars['uuid']['input']>;
  preventGitWebhookDelete?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Sites_Obj_Rel_Insert_Input>;
  siteById?: InputMaybe<Sites_Obj_Rel_Insert_Input>;
  siteDeployment?: InputMaybe<SiteDeployments_Obj_Rel_Insert_Input>;
  siteDeploymentId?: InputMaybe<Scalars['uuid']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SiteInstanceStatuses_Obj_Rel_Insert_Input>;
  statusId?: InputMaybe<SiteInstanceStatuses_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "siteInstances" */
export type SiteInstances_Max_Order_By = {
  appClientDataMajorVersion?: InputMaybe<Order_By>;
  appStateDataSetId?: InputMaybe<Order_By>;
  authorId?: InputMaybe<Order_By>;
  dateCreated?: InputMaybe<Order_By>;
  dateUpdated?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  gitBranch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastCommittedDataChangeId?: InputMaybe<Order_By>;
  siteDeploymentId?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "siteInstances" */
export type SiteInstances_Min_Order_By = {
  appClientDataMajorVersion?: InputMaybe<Order_By>;
  appStateDataSetId?: InputMaybe<Order_By>;
  authorId?: InputMaybe<Order_By>;
  dateCreated?: InputMaybe<Order_By>;
  dateUpdated?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  gitBranch?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastCommittedDataChangeId?: InputMaybe<Order_By>;
  siteDeploymentId?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "siteInstances" */
export type SiteInstances_Obj_Rel_Insert_Input = {
  data: SiteInstances_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<SiteInstances_On_Conflict>;
};

/** on_conflict condition type for table "siteInstances" */
export type SiteInstances_On_Conflict = {
  constraint: SiteInstances_Constraint;
  update_columns?: Array<SiteInstances_Update_Column>;
  where?: InputMaybe<SiteInstances_Bool_Exp>;
};

/** Ordering options when selecting data from "siteInstances". */
export type SiteInstances_Order_By = {
  appClientDataMajorVersion?: InputMaybe<Order_By>;
  appState?: InputMaybe<DataSets_Order_By>;
  appStateDataSetId?: InputMaybe<Order_By>;
  author?: InputMaybe<Users_Order_By>;
  authorId?: InputMaybe<Order_By>;
  dataChanges_aggregate?: InputMaybe<DataChanges_Aggregate_Order_By>;
  dateCreated?: InputMaybe<Order_By>;
  dateUpdated?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  gitBranch?: InputMaybe<Order_By>;
  histories_aggregate?: InputMaybe<SiteInstanceHistories_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  lastCommittedDataChange?: InputMaybe<DataChanges_Order_By>;
  lastCommittedDataChangeId?: InputMaybe<Order_By>;
  preventGitWebhookDelete?: InputMaybe<Order_By>;
  site?: InputMaybe<Sites_Order_By>;
  siteById?: InputMaybe<Sites_Order_By>;
  siteDeployment?: InputMaybe<SiteDeployments_Order_By>;
  siteDeploymentId?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  status?: InputMaybe<SiteInstanceStatuses_Order_By>;
  statusId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: siteInstances */
export type SiteInstances_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "siteInstances" */
export type SiteInstances_Select_Column =
  /** column name */
  | 'appClientDataMajorVersion'
  /** column name */
  | 'appStateDataSetId'
  /** column name */
  | 'authorId'
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'dateUpdated'
  /** column name */
  | 'description'
  /** column name */
  | 'gitBranch'
  /** column name */
  | 'id'
  /** column name */
  | 'lastCommittedDataChangeId'
  /** column name */
  | 'preventGitWebhookDelete'
  /** column name */
  | 'siteDeploymentId'
  /** column name */
  | 'siteId'
  /** column name */
  | 'statusId'
  /** column name */
  | 'title';

/** select "siteInstances_aggregate_bool_exp_bool_and_arguments_columns" columns of table "siteInstances" */
export type SiteInstances_Select_Column_SiteInstances_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'preventGitWebhookDelete';

/** select "siteInstances_aggregate_bool_exp_bool_or_arguments_columns" columns of table "siteInstances" */
export type SiteInstances_Select_Column_SiteInstances_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'preventGitWebhookDelete';

/** input type for updating data in table "siteInstances" */
export type SiteInstances_Set_Input = {
  appClientDataMajorVersion?: InputMaybe<Scalars['Int']['input']>;
  appStateDataSetId?: InputMaybe<Scalars['String']['input']>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  dateUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gitBranch?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCommittedDataChangeId?: InputMaybe<Scalars['uuid']['input']>;
  preventGitWebhookDelete?: InputMaybe<Scalars['Boolean']['input']>;
  siteDeploymentId?: InputMaybe<Scalars['uuid']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<SiteInstanceStatuses_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "siteInstances" */
export type SiteInstances_Stddev_Order_By = {
  appClientDataMajorVersion?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "siteInstances" */
export type SiteInstances_Stddev_Pop_Order_By = {
  appClientDataMajorVersion?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "siteInstances" */
export type SiteInstances_Stddev_Samp_Order_By = {
  appClientDataMajorVersion?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "siteInstances" */
export type SiteInstances_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SiteInstances_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SiteInstances_Stream_Cursor_Value_Input = {
  appClientDataMajorVersion?: InputMaybe<Scalars['Int']['input']>;
  appStateDataSetId?: InputMaybe<Scalars['String']['input']>;
  authorId?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  dateUpdated?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gitBranch?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastCommittedDataChangeId?: InputMaybe<Scalars['uuid']['input']>;
  preventGitWebhookDelete?: InputMaybe<Scalars['Boolean']['input']>;
  siteDeploymentId?: InputMaybe<Scalars['uuid']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<SiteInstanceStatuses_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "siteInstances" */
export type SiteInstances_Sum_Order_By = {
  appClientDataMajorVersion?: InputMaybe<Order_By>;
};

/** update columns of table "siteInstances" */
export type SiteInstances_Update_Column =
  /** column name */
  | 'appClientDataMajorVersion'
  /** column name */
  | 'appStateDataSetId'
  /** column name */
  | 'authorId'
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'dateUpdated'
  /** column name */
  | 'description'
  /** column name */
  | 'gitBranch'
  /** column name */
  | 'id'
  /** column name */
  | 'lastCommittedDataChangeId'
  /** column name */
  | 'preventGitWebhookDelete'
  /** column name */
  | 'siteDeploymentId'
  /** column name */
  | 'siteId'
  /** column name */
  | 'statusId'
  /** column name */
  | 'title';

export type SiteInstances_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SiteInstances_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SiteInstances_Set_Input>;
  /** filter the rows which have to be updated */
  where: SiteInstances_Bool_Exp;
};

/** order by var_pop() on columns of table "siteInstances" */
export type SiteInstances_Var_Pop_Order_By = {
  appClientDataMajorVersion?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "siteInstances" */
export type SiteInstances_Var_Samp_Order_By = {
  appClientDataMajorVersion?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "siteInstances" */
export type SiteInstances_Variance_Order_By = {
  appClientDataMajorVersion?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "siteNotes". All fields are combined with a logical 'AND'. */
export type SiteNotes_Bool_Exp = {
  _and?: InputMaybe<Array<SiteNotes_Bool_Exp>>;
  _not?: InputMaybe<SiteNotes_Bool_Exp>;
  _or?: InputMaybe<Array<SiteNotes_Bool_Exp>>;
  notes?: InputMaybe<String_Comparison_Exp>;
  siteId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "siteNotes" */
export type SiteNotes_Constraint =
  /** unique or primary key constraint on columns "siteId" */
  | 'siteNotes_pkey';

/** input type for inserting data into table "siteNotes" */
export type SiteNotes_Insert_Input = {
  notes?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting object relation for remote table "siteNotes" */
export type SiteNotes_Obj_Rel_Insert_Input = {
  data: SiteNotes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<SiteNotes_On_Conflict>;
};

/** on_conflict condition type for table "siteNotes" */
export type SiteNotes_On_Conflict = {
  constraint: SiteNotes_Constraint;
  update_columns?: Array<SiteNotes_Update_Column>;
  where?: InputMaybe<SiteNotes_Bool_Exp>;
};

/** Ordering options when selecting data from "siteNotes". */
export type SiteNotes_Order_By = {
  notes?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: siteNotes */
export type SiteNotes_Pk_Columns_Input = {
  siteId: Scalars['String']['input'];
};

/** select columns of table "siteNotes" */
export type SiteNotes_Select_Column =
  /** column name */
  | 'notes'
  /** column name */
  | 'siteId';

/** input type for updating data in table "siteNotes" */
export type SiteNotes_Set_Input = {
  notes?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "siteNotes" */
export type SiteNotes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SiteNotes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SiteNotes_Stream_Cursor_Value_Input = {
  notes?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "siteNotes" */
export type SiteNotes_Update_Column =
  /** column name */
  | 'notes'
  /** column name */
  | 'siteId';

export type SiteNotes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SiteNotes_Set_Input>;
  /** filter the rows which have to be updated */
  where: SiteNotes_Bool_Exp;
};

/** Boolean expression to filter rows from the table "siteStatuses". All fields are combined with a logical 'AND'. */
export type SiteStatuses_Bool_Exp = {
  _and?: InputMaybe<Array<SiteStatuses_Bool_Exp>>;
  _not?: InputMaybe<SiteStatuses_Bool_Exp>;
  _or?: InputMaybe<Array<SiteStatuses_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "siteStatuses" */
export type SiteStatuses_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'siteStatuses_pkey'
  /** unique or primary key constraint on columns "title" */
  | 'siteStatuses_title_key';

export type SiteStatuses_Enum =
  /** Active */
  | 'ACTIVE'
  /** Archived */
  | 'ARCHIVED'
  /** Disabled */
  | 'DISABLED'
  /** Inactive */
  | 'INACTIVE'
  /** Preparing */
  | 'PREPARING';

/** Boolean expression to compare columns of type "siteStatuses_enum". All fields are combined with logical 'AND'. */
export type SiteStatuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<SiteStatuses_Enum>;
  _in?: InputMaybe<Array<SiteStatuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<SiteStatuses_Enum>;
  _nin?: InputMaybe<Array<SiteStatuses_Enum>>;
};

/** input type for inserting data into table "siteStatuses" */
export type SiteStatuses_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** on_conflict condition type for table "siteStatuses" */
export type SiteStatuses_On_Conflict = {
  constraint: SiteStatuses_Constraint;
  update_columns?: Array<SiteStatuses_Update_Column>;
  where?: InputMaybe<SiteStatuses_Bool_Exp>;
};

/** Ordering options when selecting data from "siteStatuses". */
export type SiteStatuses_Order_By = {
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: siteStatuses */
export type SiteStatuses_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "siteStatuses" */
export type SiteStatuses_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

/** input type for updating data in table "siteStatuses" */
export type SiteStatuses_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "siteStatuses" */
export type SiteStatuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SiteStatuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SiteStatuses_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "siteStatuses" */
export type SiteStatuses_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'title';

export type SiteStatuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SiteStatuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: SiteStatuses_Bool_Exp;
};

export type SitesUsers_Aggregate_Bool_Exp = {
  count?: InputMaybe<SitesUsers_Aggregate_Bool_Exp_Count>;
};

export type SitesUsers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<SitesUsers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SitesUsers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** order by aggregate values of table "sitesUsers" */
export type SitesUsers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SitesUsers_Max_Order_By>;
  min?: InputMaybe<SitesUsers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "sitesUsers" */
export type SitesUsers_Arr_Rel_Insert_Input = {
  data: Array<SitesUsers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SitesUsers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "sitesUsers". All fields are combined with a logical 'AND'. */
export type SitesUsers_Bool_Exp = {
  _and?: InputMaybe<Array<SitesUsers_Bool_Exp>>;
  _not?: InputMaybe<SitesUsers_Bool_Exp>;
  _or?: InputMaybe<Array<SitesUsers_Bool_Exp>>;
  role?: InputMaybe<Roles_Bool_Exp>;
  roleId?: InputMaybe<Roles_Enum_Comparison_Exp>;
  site?: InputMaybe<Sites_Bool_Exp>;
  siteId?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sitesUsers" */
export type SitesUsers_Constraint =
  /** unique or primary key constraint on columns "userId", "siteId" */
  | 'sitesUsers_pkey';

/** input type for inserting data into table "sitesUsers" */
export type SitesUsers_Insert_Input = {
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  roleId?: InputMaybe<Roles_Enum>;
  site?: InputMaybe<Sites_Obj_Rel_Insert_Input>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "sitesUsers" */
export type SitesUsers_Max_Order_By = {
  siteId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "sitesUsers" */
export type SitesUsers_Min_Order_By = {
  siteId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "sitesUsers" */
export type SitesUsers_On_Conflict = {
  constraint: SitesUsers_Constraint;
  update_columns?: Array<SitesUsers_Update_Column>;
  where?: InputMaybe<SitesUsers_Bool_Exp>;
};

/** Ordering options when selecting data from "sitesUsers". */
export type SitesUsers_Order_By = {
  role?: InputMaybe<Roles_Order_By>;
  roleId?: InputMaybe<Order_By>;
  site?: InputMaybe<Sites_Order_By>;
  siteId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sitesUsers */
export type SitesUsers_Pk_Columns_Input = {
  siteId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** select columns of table "sitesUsers" */
export type SitesUsers_Select_Column =
  /** column name */
  | 'roleId'
  /** column name */
  | 'siteId'
  /** column name */
  | 'userId';

/** input type for updating data in table "sitesUsers" */
export type SitesUsers_Set_Input = {
  roleId?: InputMaybe<Roles_Enum>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "sitesUsers" */
export type SitesUsers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SitesUsers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SitesUsers_Stream_Cursor_Value_Input = {
  roleId?: InputMaybe<Roles_Enum>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "sitesUsers" */
export type SitesUsers_Update_Column =
  /** column name */
  | 'roleId'
  /** column name */
  | 'siteId'
  /** column name */
  | 'userId';

export type SitesUsers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SitesUsers_Set_Input>;
  /** filter the rows which have to be updated */
  where: SitesUsers_Bool_Exp;
};

export type Sites_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Sites_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Sites_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Sites_Aggregate_Bool_Exp_Count>;
};

export type Sites_Aggregate_Bool_Exp_Bool_And = {
  arguments: Sites_Select_Column_Sites_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sites_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sites_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Sites_Select_Column_Sites_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sites_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sites_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sites_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** order by aggregate values of table "sites" */
export type Sites_Aggregate_Order_By = {
  avg?: InputMaybe<Sites_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sites_Max_Order_By>;
  min?: InputMaybe<Sites_Min_Order_By>;
  stddev?: InputMaybe<Sites_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sites_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sites_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sites_Sum_Order_By>;
  var_pop?: InputMaybe<Sites_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sites_Var_Samp_Order_By>;
  variance?: InputMaybe<Sites_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sites" */
export type Sites_Arr_Rel_Insert_Input = {
  data: Array<Sites_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sites_On_Conflict>;
};

/** order by avg() on columns of table "sites" */
export type Sites_Avg_Order_By = {
  billingDate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sites". All fields are combined with a logical 'AND'. */
export type Sites_Bool_Exp = {
  _and?: InputMaybe<Array<Sites_Bool_Exp>>;
  _not?: InputMaybe<Sites_Bool_Exp>;
  _or?: InputMaybe<Array<Sites_Bool_Exp>>;
  billingDate?: InputMaybe<Int_Comparison_Exp>;
  billingPlan?: InputMaybe<String_Comparison_Exp>;
  dateCreated?: InputMaybe<Timestamptz_Comparison_Exp>;
  deployments?: InputMaybe<SiteDeployments_Bool_Exp>;
  deployments_aggregate?: InputMaybe<SiteDeployments_Aggregate_Bool_Exp>;
  draftInstance?: InputMaybe<SiteInstances_Bool_Exp>;
  draftInstanceId?: InputMaybe<String_Comparison_Exp>;
  excludeFromAnalytics?: InputMaybe<Boolean_Comparison_Exp>;
  gitProvider?: InputMaybe<GitProviders_Enum_Comparison_Exp>;
  homeImageUrl?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isClientActive?: InputMaybe<Boolean_Comparison_Exp>;
  isKsContentStoredInDb?: InputMaybe<Boolean_Comparison_Exp>;
  isPrivate?: InputMaybe<Boolean_Comparison_Exp>;
  isProposeChangeEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  latestClientVersion?: InputMaybe<String_Comparison_Exp>;
  latestInstance?: InputMaybe<SiteInstances_Bool_Exp>;
  latestInstanceId?: InputMaybe<String_Comparison_Exp>;
  latestUrl?: InputMaybe<String_Comparison_Exp>;
  logoUrl?: InputMaybe<String_Comparison_Exp>;
  org?: InputMaybe<Orgs_Bool_Exp>;
  orgId?: InputMaybe<String_Comparison_Exp>;
  plan?: InputMaybe<Plans_Bool_Exp>;
  planId?: InputMaybe<Plans_Enum_Comparison_Exp>;
  repo?: InputMaybe<String_Comparison_Exp>;
  siteInstances?: InputMaybe<SiteInstances_Bool_Exp>;
  siteInstances_aggregate?: InputMaybe<SiteInstances_Aggregate_Bool_Exp>;
  siteNotes?: InputMaybe<SiteNotes_Bool_Exp>;
  ssoConfigs?: InputMaybe<SsoConfig_Bool_Exp>;
  ssoConfigs_aggregate?: InputMaybe<SsoConfig_Aggregate_Bool_Exp>;
  status?: InputMaybe<SiteStatuses_Enum_Comparison_Exp>;
  stripeCustomerId?: InputMaybe<String_Comparison_Exp>;
  stripeSubscriptionId?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  uiConfig?: InputMaybe<Json_Comparison_Exp>;
  users?: InputMaybe<SitesUsers_Bool_Exp>;
  users_aggregate?: InputMaybe<SitesUsers_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "sites" */
export type Sites_Constraint =
  /** unique or primary key constraint on columns "draftInstanceId" */
  | 'sites_draftInstanceId_key'
  /** unique or primary key constraint on columns "latestInstanceId" */
  | 'sites_latestInstanceId_key1'
  /** unique or primary key constraint on columns "id" */
  | 'sites_pkey'
  /** unique or primary key constraint on columns "stripeCustomerId" */
  | 'sites_stripeCustomerId_key'
  /** unique or primary key constraint on columns "stripeSubscriptionId" */
  | 'sites_stripeSubscriptionId_key';

/** input type for incrementing numeric columns in table "sites" */
export type Sites_Inc_Input = {
  billingDate?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "sites" */
export type Sites_Insert_Input = {
  billingDate?: InputMaybe<Scalars['Int']['input']>;
  billingPlan?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  deployments?: InputMaybe<SiteDeployments_Arr_Rel_Insert_Input>;
  draftInstance?: InputMaybe<SiteInstances_Obj_Rel_Insert_Input>;
  draftInstanceId?: InputMaybe<Scalars['String']['input']>;
  excludeFromAnalytics?: InputMaybe<Scalars['Boolean']['input']>;
  gitProvider?: InputMaybe<GitProviders_Enum>;
  homeImageUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isClientActive?: InputMaybe<Scalars['Boolean']['input']>;
  isKsContentStoredInDb?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, then you must be a user on the site to view */
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isProposeChangeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  latestClientVersion?: InputMaybe<Scalars['String']['input']>;
  latestInstance?: InputMaybe<SiteInstances_Obj_Rel_Insert_Input>;
  latestInstanceId?: InputMaybe<Scalars['String']['input']>;
  latestUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  org?: InputMaybe<Orgs_Obj_Rel_Insert_Input>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Plans_Obj_Rel_Insert_Input>;
  planId?: InputMaybe<Plans_Enum>;
  repo?: InputMaybe<Scalars['String']['input']>;
  siteInstances?: InputMaybe<SiteInstances_Arr_Rel_Insert_Input>;
  siteNotes?: InputMaybe<SiteNotes_Obj_Rel_Insert_Input>;
  ssoConfigs?: InputMaybe<SsoConfig_Arr_Rel_Insert_Input>;
  status?: InputMaybe<SiteStatuses_Enum>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uiConfig?: InputMaybe<Scalars['json']['input']>;
  users?: InputMaybe<SitesUsers_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "sites" */
export type Sites_Max_Order_By = {
  billingDate?: InputMaybe<Order_By>;
  billingPlan?: InputMaybe<Order_By>;
  dateCreated?: InputMaybe<Order_By>;
  draftInstanceId?: InputMaybe<Order_By>;
  homeImageUrl?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestClientVersion?: InputMaybe<Order_By>;
  latestInstanceId?: InputMaybe<Order_By>;
  latestUrl?: InputMaybe<Order_By>;
  logoUrl?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  repo?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  stripeSubscriptionId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "sites" */
export type Sites_Min_Order_By = {
  billingDate?: InputMaybe<Order_By>;
  billingPlan?: InputMaybe<Order_By>;
  dateCreated?: InputMaybe<Order_By>;
  draftInstanceId?: InputMaybe<Order_By>;
  homeImageUrl?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latestClientVersion?: InputMaybe<Order_By>;
  latestInstanceId?: InputMaybe<Order_By>;
  latestUrl?: InputMaybe<Order_By>;
  logoUrl?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  repo?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  stripeSubscriptionId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** input type for inserting object relation for remote table "sites" */
export type Sites_Obj_Rel_Insert_Input = {
  data: Sites_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sites_On_Conflict>;
};

/** on_conflict condition type for table "sites" */
export type Sites_On_Conflict = {
  constraint: Sites_Constraint;
  update_columns?: Array<Sites_Update_Column>;
  where?: InputMaybe<Sites_Bool_Exp>;
};

/** Ordering options when selecting data from "sites". */
export type Sites_Order_By = {
  billingDate?: InputMaybe<Order_By>;
  billingPlan?: InputMaybe<Order_By>;
  dateCreated?: InputMaybe<Order_By>;
  deployments_aggregate?: InputMaybe<SiteDeployments_Aggregate_Order_By>;
  draftInstance?: InputMaybe<SiteInstances_Order_By>;
  draftInstanceId?: InputMaybe<Order_By>;
  excludeFromAnalytics?: InputMaybe<Order_By>;
  gitProvider?: InputMaybe<Order_By>;
  homeImageUrl?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isClientActive?: InputMaybe<Order_By>;
  isKsContentStoredInDb?: InputMaybe<Order_By>;
  isPrivate?: InputMaybe<Order_By>;
  isProposeChangeEnabled?: InputMaybe<Order_By>;
  latestClientVersion?: InputMaybe<Order_By>;
  latestInstance?: InputMaybe<SiteInstances_Order_By>;
  latestInstanceId?: InputMaybe<Order_By>;
  latestUrl?: InputMaybe<Order_By>;
  logoUrl?: InputMaybe<Order_By>;
  org?: InputMaybe<Orgs_Order_By>;
  orgId?: InputMaybe<Order_By>;
  plan?: InputMaybe<Plans_Order_By>;
  planId?: InputMaybe<Order_By>;
  repo?: InputMaybe<Order_By>;
  siteInstances_aggregate?: InputMaybe<SiteInstances_Aggregate_Order_By>;
  siteNotes?: InputMaybe<SiteNotes_Order_By>;
  ssoConfigs_aggregate?: InputMaybe<SsoConfig_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  stripeCustomerId?: InputMaybe<Order_By>;
  stripeSubscriptionId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  uiConfig?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<SitesUsers_Aggregate_Order_By>;
};

/** primary key columns input for table: sites */
export type Sites_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "sites" */
export type Sites_Select_Column =
  /** column name */
  | 'billingDate'
  /** column name */
  | 'billingPlan'
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'draftInstanceId'
  /** column name */
  | 'excludeFromAnalytics'
  /** column name */
  | 'gitProvider'
  /** column name */
  | 'homeImageUrl'
  /** column name */
  | 'id'
  /** column name */
  | 'isClientActive'
  /** column name */
  | 'isKsContentStoredInDb'
  /** column name */
  | 'isPrivate'
  /** column name */
  | 'isProposeChangeEnabled'
  /** column name */
  | 'latestClientVersion'
  /** column name */
  | 'latestInstanceId'
  /** column name */
  | 'latestUrl'
  /** column name */
  | 'logoUrl'
  /** column name */
  | 'orgId'
  /** column name */
  | 'planId'
  /** column name */
  | 'repo'
  /** column name */
  | 'status'
  /** column name */
  | 'stripeCustomerId'
  /** column name */
  | 'stripeSubscriptionId'
  /** column name */
  | 'title'
  /** column name */
  | 'uiConfig';

/** select "sites_aggregate_bool_exp_bool_and_arguments_columns" columns of table "sites" */
export type Sites_Select_Column_Sites_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'excludeFromAnalytics'
  /** column name */
  | 'isClientActive'
  /** column name */
  | 'isKsContentStoredInDb'
  /** column name */
  | 'isPrivate'
  /** column name */
  | 'isProposeChangeEnabled';

/** select "sites_aggregate_bool_exp_bool_or_arguments_columns" columns of table "sites" */
export type Sites_Select_Column_Sites_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'excludeFromAnalytics'
  /** column name */
  | 'isClientActive'
  /** column name */
  | 'isKsContentStoredInDb'
  /** column name */
  | 'isPrivate'
  /** column name */
  | 'isProposeChangeEnabled';

/** input type for updating data in table "sites" */
export type Sites_Set_Input = {
  billingDate?: InputMaybe<Scalars['Int']['input']>;
  billingPlan?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  draftInstanceId?: InputMaybe<Scalars['String']['input']>;
  excludeFromAnalytics?: InputMaybe<Scalars['Boolean']['input']>;
  gitProvider?: InputMaybe<GitProviders_Enum>;
  homeImageUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isClientActive?: InputMaybe<Scalars['Boolean']['input']>;
  isKsContentStoredInDb?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, then you must be a user on the site to view */
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isProposeChangeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  latestClientVersion?: InputMaybe<Scalars['String']['input']>;
  latestInstanceId?: InputMaybe<Scalars['String']['input']>;
  latestUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Plans_Enum>;
  repo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SiteStatuses_Enum>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uiConfig?: InputMaybe<Scalars['json']['input']>;
};

/** order by stddev() on columns of table "sites" */
export type Sites_Stddev_Order_By = {
  billingDate?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "sites" */
export type Sites_Stddev_Pop_Order_By = {
  billingDate?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "sites" */
export type Sites_Stddev_Samp_Order_By = {
  billingDate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sites" */
export type Sites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sites_Stream_Cursor_Value_Input = {
  billingDate?: InputMaybe<Scalars['Int']['input']>;
  billingPlan?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  draftInstanceId?: InputMaybe<Scalars['String']['input']>;
  excludeFromAnalytics?: InputMaybe<Scalars['Boolean']['input']>;
  gitProvider?: InputMaybe<GitProviders_Enum>;
  homeImageUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isClientActive?: InputMaybe<Scalars['Boolean']['input']>;
  isKsContentStoredInDb?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, then you must be a user on the site to view */
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isProposeChangeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  latestClientVersion?: InputMaybe<Scalars['String']['input']>;
  latestInstanceId?: InputMaybe<Scalars['String']['input']>;
  latestUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Plans_Enum>;
  repo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SiteStatuses_Enum>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uiConfig?: InputMaybe<Scalars['json']['input']>;
};

/** order by sum() on columns of table "sites" */
export type Sites_Sum_Order_By = {
  billingDate?: InputMaybe<Order_By>;
};

/** update columns of table "sites" */
export type Sites_Update_Column =
  /** column name */
  | 'billingDate'
  /** column name */
  | 'billingPlan'
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'draftInstanceId'
  /** column name */
  | 'excludeFromAnalytics'
  /** column name */
  | 'gitProvider'
  /** column name */
  | 'homeImageUrl'
  /** column name */
  | 'id'
  /** column name */
  | 'isClientActive'
  /** column name */
  | 'isKsContentStoredInDb'
  /** column name */
  | 'isPrivate'
  /** column name */
  | 'isProposeChangeEnabled'
  /** column name */
  | 'latestClientVersion'
  /** column name */
  | 'latestInstanceId'
  /** column name */
  | 'latestUrl'
  /** column name */
  | 'logoUrl'
  /** column name */
  | 'orgId'
  /** column name */
  | 'planId'
  /** column name */
  | 'repo'
  /** column name */
  | 'status'
  /** column name */
  | 'stripeCustomerId'
  /** column name */
  | 'stripeSubscriptionId'
  /** column name */
  | 'title'
  /** column name */
  | 'uiConfig';

export type Sites_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sites_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sites_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sites_Bool_Exp;
};

/** order by var_pop() on columns of table "sites" */
export type Sites_Var_Pop_Order_By = {
  billingDate?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "sites" */
export type Sites_Var_Samp_Order_By = {
  billingDate?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "sites" */
export type Sites_Variance_Order_By = {
  billingDate?: InputMaybe<Order_By>;
};

export type SsoConfig_Aggregate_Bool_Exp = {
  count?: InputMaybe<SsoConfig_Aggregate_Bool_Exp_Count>;
};

export type SsoConfig_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<SsoConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SsoConfig_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** order by aggregate values of table "ssoConfig" */
export type SsoConfig_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SsoConfig_Max_Order_By>;
  min?: InputMaybe<SsoConfig_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ssoConfig" */
export type SsoConfig_Arr_Rel_Insert_Input = {
  data: Array<SsoConfig_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SsoConfig_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ssoConfig". All fields are combined with a logical 'AND'. */
export type SsoConfig_Bool_Exp = {
  _and?: InputMaybe<Array<SsoConfig_Bool_Exp>>;
  _not?: InputMaybe<SsoConfig_Bool_Exp>;
  _or?: InputMaybe<Array<SsoConfig_Bool_Exp>>;
  authConnection?: InputMaybe<AuthConnections_Bool_Exp>;
  authConnectionId?: InputMaybe<String_Comparison_Exp>;
  site?: InputMaybe<Sites_Bool_Exp>;
  siteId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ssoConfig" */
export type SsoConfig_Constraint =
  /** unique or primary key constraint on columns "authConnectionId", "siteId" */
  | 'ssoConfig_pkey';

/** input type for inserting data into table "ssoConfig" */
export type SsoConfig_Insert_Input = {
  authConnection?: InputMaybe<AuthConnections_Obj_Rel_Insert_Input>;
  authConnectionId?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Sites_Obj_Rel_Insert_Input>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "ssoConfig" */
export type SsoConfig_Max_Order_By = {
  authConnectionId?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "ssoConfig" */
export type SsoConfig_Min_Order_By = {
  authConnectionId?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "ssoConfig" */
export type SsoConfig_On_Conflict = {
  constraint: SsoConfig_Constraint;
  update_columns?: Array<SsoConfig_Update_Column>;
  where?: InputMaybe<SsoConfig_Bool_Exp>;
};

/** Ordering options when selecting data from "ssoConfig". */
export type SsoConfig_Order_By = {
  authConnection?: InputMaybe<AuthConnections_Order_By>;
  authConnectionId?: InputMaybe<Order_By>;
  site?: InputMaybe<Sites_Order_By>;
  siteId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ssoConfig */
export type SsoConfig_Pk_Columns_Input = {
  authConnectionId: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
};

/** select columns of table "ssoConfig" */
export type SsoConfig_Select_Column =
  /** column name */
  | 'authConnectionId'
  /** column name */
  | 'siteId';

/** input type for updating data in table "ssoConfig" */
export type SsoConfig_Set_Input = {
  authConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ssoConfig" */
export type SsoConfig_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SsoConfig_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SsoConfig_Stream_Cursor_Value_Input = {
  authConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "ssoConfig" */
export type SsoConfig_Update_Column =
  /** column name */
  | 'authConnectionId'
  /** column name */
  | 'siteId';

export type SsoConfig_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SsoConfig_Set_Input>;
  /** filter the rows which have to be updated */
  where: SsoConfig_Bool_Exp;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Boolean expression to filter rows from the table "userInvites". All fields are combined with a logical 'AND'. */
export type UserInvites_Bool_Exp = {
  _and?: InputMaybe<Array<UserInvites_Bool_Exp>>;
  _not?: InputMaybe<UserInvites_Bool_Exp>;
  _or?: InputMaybe<Array<UserInvites_Bool_Exp>>;
  dateCreated?: InputMaybe<Timestamptz_Comparison_Exp>;
  dateOfInviteExpiration?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  inviterUserId?: InputMaybe<String_Comparison_Exp>;
  isUserPass?: InputMaybe<Boolean_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  roleId?: InputMaybe<Roles_Enum_Comparison_Exp>;
  site?: InputMaybe<Sites_Bool_Exp>;
  siteId?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "userInvites" */
export type UserInvites_Constraint =
  /** unique or primary key constraint on columns "email", "siteId" */
  | 'userInvites_pkey';

/** input type for inserting data into table "userInvites" */
export type UserInvites_Insert_Input = {
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Only username/password invites have an expiration date from auth0. */
  dateOfInviteExpiration?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The email of the person being invited. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Who actually sent the invite. */
  inviterUserId?: InputMaybe<Scalars['String']['input']>;
  /** There are two types of authorized users: SSO and username/password. This lets us avoid an enum. */
  isUserPass?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  roleId?: InputMaybe<Roles_Enum>;
  site?: InputMaybe<Sites_Obj_Rel_Insert_Input>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** on_conflict condition type for table "userInvites" */
export type UserInvites_On_Conflict = {
  constraint: UserInvites_Constraint;
  update_columns?: Array<UserInvites_Update_Column>;
  where?: InputMaybe<UserInvites_Bool_Exp>;
};

/** Ordering options when selecting data from "userInvites". */
export type UserInvites_Order_By = {
  dateCreated?: InputMaybe<Order_By>;
  dateOfInviteExpiration?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  inviterUserId?: InputMaybe<Order_By>;
  isUserPass?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  roleId?: InputMaybe<Order_By>;
  site?: InputMaybe<Sites_Order_By>;
  siteId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: userInvites */
export type UserInvites_Pk_Columns_Input = {
  /** The email of the person being invited. */
  email: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
};

/** select columns of table "userInvites" */
export type UserInvites_Select_Column =
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'dateOfInviteExpiration'
  /** column name */
  | 'email'
  /** column name */
  | 'inviterUserId'
  /** column name */
  | 'isUserPass'
  /** column name */
  | 'roleId'
  /** column name */
  | 'siteId';

/** input type for updating data in table "userInvites" */
export type UserInvites_Set_Input = {
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Only username/password invites have an expiration date from auth0. */
  dateOfInviteExpiration?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The email of the person being invited. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Who actually sent the invite. */
  inviterUserId?: InputMaybe<Scalars['String']['input']>;
  /** There are two types of authorized users: SSO and username/password. This lets us avoid an enum. */
  isUserPass?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Roles_Enum>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "userInvites" */
export type UserInvites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserInvites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserInvites_Stream_Cursor_Value_Input = {
  dateCreated?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Only username/password invites have an expiration date from auth0. */
  dateOfInviteExpiration?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The email of the person being invited. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Who actually sent the invite. */
  inviterUserId?: InputMaybe<Scalars['String']['input']>;
  /** There are two types of authorized users: SSO and username/password. This lets us avoid an enum. */
  isUserPass?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Roles_Enum>;
  siteId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "userInvites" */
export type UserInvites_Update_Column =
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'dateOfInviteExpiration'
  /** column name */
  | 'email'
  /** column name */
  | 'inviterUserId'
  /** column name */
  | 'isUserPass'
  /** column name */
  | 'roleId'
  /** column name */
  | 'siteId';

export type UserInvites_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserInvites_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserInvites_Bool_Exp;
};

/** Boolean expression to filter rows from the table "usersOAuth". All fields are combined with a logical 'AND'. */
export type UsersOAuth_Bool_Exp = {
  _and?: InputMaybe<Array<UsersOAuth_Bool_Exp>>;
  _not?: InputMaybe<UsersOAuth_Bool_Exp>;
  _or?: InputMaybe<Array<UsersOAuth_Bool_Exp>>;
  accessToken?: InputMaybe<String_Comparison_Exp>;
  expiresAt?: InputMaybe<Timestamp_Comparison_Exp>;
  oAuthSource?: InputMaybe<OAuthSources_Bool_Exp>;
  oAuthSourceId?: InputMaybe<OAuthSources_Enum_Comparison_Exp>;
  oAuthTokenStatus?: InputMaybe<OAuthTokenStatuses_Bool_Exp>;
  refreshToken?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Array_Comparison_Exp>;
  sourceUserId?: InputMaybe<String_Comparison_Exp>;
  tokenLastUsed?: InputMaybe<Timestamp_Comparison_Exp>;
  tokenLastUsedStatusId?: InputMaybe<OAuthTokenStatuses_Enum_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "usersOAuth" */
export type UsersOAuth_Constraint =
  /** unique or primary key constraint on columns "userId", "sourceUserId", "oAuthSourceId" */
  | 'usersOAuth_pkey';

/** input type for inserting data into table "usersOAuth" */
export type UsersOAuth_Insert_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamp']['input']>;
  oAuthSource?: InputMaybe<OAuthSources_Obj_Rel_Insert_Input>;
  oAuthSourceId?: InputMaybe<OAuthSources_Enum>;
  oAuthTokenStatus?: InputMaybe<OAuthTokenStatuses_Obj_Rel_Insert_Input>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceUserId?: InputMaybe<Scalars['String']['input']>;
  tokenLastUsed?: InputMaybe<Scalars['timestamp']['input']>;
  tokenLastUsedStatusId?: InputMaybe<OAuthTokenStatuses_Enum>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** on_conflict condition type for table "usersOAuth" */
export type UsersOAuth_On_Conflict = {
  constraint: UsersOAuth_Constraint;
  update_columns?: Array<UsersOAuth_Update_Column>;
  where?: InputMaybe<UsersOAuth_Bool_Exp>;
};

/** Ordering options when selecting data from "usersOAuth". */
export type UsersOAuth_Order_By = {
  accessToken?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  oAuthSource?: InputMaybe<OAuthSources_Order_By>;
  oAuthSourceId?: InputMaybe<Order_By>;
  oAuthTokenStatus?: InputMaybe<OAuthTokenStatuses_Order_By>;
  refreshToken?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  sourceUserId?: InputMaybe<Order_By>;
  tokenLastUsed?: InputMaybe<Order_By>;
  tokenLastUsedStatusId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: usersOAuth */
export type UsersOAuth_Pk_Columns_Input = {
  oAuthSourceId: OAuthSources_Enum;
  sourceUserId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** select columns of table "usersOAuth" */
export type UsersOAuth_Select_Column =
  /** column name */
  | 'accessToken'
  /** column name */
  | 'expiresAt'
  /** column name */
  | 'oAuthSourceId'
  /** column name */
  | 'refreshToken'
  /** column name */
  | 'scope'
  /** column name */
  | 'sourceUserId'
  /** column name */
  | 'tokenLastUsed'
  /** column name */
  | 'tokenLastUsedStatusId'
  /** column name */
  | 'userId';

/** input type for updating data in table "usersOAuth" */
export type UsersOAuth_Set_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamp']['input']>;
  oAuthSourceId?: InputMaybe<OAuthSources_Enum>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceUserId?: InputMaybe<Scalars['String']['input']>;
  tokenLastUsed?: InputMaybe<Scalars['timestamp']['input']>;
  tokenLastUsedStatusId?: InputMaybe<OAuthTokenStatuses_Enum>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "usersOAuth" */
export type UsersOAuth_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UsersOAuth_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersOAuth_Stream_Cursor_Value_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamp']['input']>;
  oAuthSourceId?: InputMaybe<OAuthSources_Enum>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceUserId?: InputMaybe<Scalars['String']['input']>;
  tokenLastUsed?: InputMaybe<Scalars['timestamp']['input']>;
  tokenLastUsedStatusId?: InputMaybe<OAuthTokenStatuses_Enum>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "usersOAuth" */
export type UsersOAuth_Update_Column =
  /** column name */
  | 'accessToken'
  /** column name */
  | 'expiresAt'
  /** column name */
  | 'oAuthSourceId'
  /** column name */
  | 'refreshToken'
  /** column name */
  | 'scope'
  /** column name */
  | 'sourceUserId'
  /** column name */
  | 'tokenLastUsed'
  /** column name */
  | 'tokenLastUsedStatusId'
  /** column name */
  | 'userId';

export type UsersOAuth_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersOAuth_Set_Input>;
  /** filter the rows which have to be updated */
  where: UsersOAuth_Bool_Exp;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  auth0Id?: InputMaybe<String_Comparison_Exp>;
  dateCreated?: InputMaybe<Date_Comparison_Exp>;
  dateLastActive?: InputMaybe<Date_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isSuperAdmin?: InputMaybe<Boolean_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  lastSeenChangelog?: InputMaybe<String_Comparison_Exp>;
  profilePic?: InputMaybe<String_Comparison_Exp>;
  responsibility?: InputMaybe<Responsibilities_Bool_Exp>;
  responsibilityId?: InputMaybe<Responsibilities_Enum_Comparison_Exp>;
  sites?: InputMaybe<SitesUsers_Bool_Exp>;
  sites_aggregate?: InputMaybe<SitesUsers_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export type Users_Constraint =
  /** unique or primary key constraint on columns "auth0Id" */
  | 'users_auth0Id_key'
  /** unique or primary key constraint on columns "email" */
  | 'users_email_key'
  /** unique or primary key constraint on columns "id" */
  | 'users_pkey';

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Scalars['date']['input']>;
  dateLastActive?: InputMaybe<Scalars['date']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSuperAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastSeenChangelog?: InputMaybe<Scalars['String']['input']>;
  profilePic?: InputMaybe<Scalars['String']['input']>;
  responsibility?: InputMaybe<Responsibilities_Obj_Rel_Insert_Input>;
  responsibilityId?: InputMaybe<Responsibilities_Enum>;
  sites?: InputMaybe<SitesUsers_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  auth0Id?: InputMaybe<Order_By>;
  dateCreated?: InputMaybe<Order_By>;
  dateLastActive?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isSuperAdmin?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  lastSeenChangelog?: InputMaybe<Order_By>;
  profilePic?: InputMaybe<Order_By>;
  responsibility?: InputMaybe<Responsibilities_Order_By>;
  responsibilityId?: InputMaybe<Order_By>;
  sites_aggregate?: InputMaybe<SitesUsers_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "users" */
export type Users_Select_Column =
  /** column name */
  | 'auth0Id'
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'dateLastActive'
  /** column name */
  | 'displayName'
  /** column name */
  | 'email'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'isSuperAdmin'
  /** column name */
  | 'lastName'
  /** column name */
  | 'lastSeenChangelog'
  /** column name */
  | 'profilePic'
  /** column name */
  | 'responsibilityId';

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Scalars['date']['input']>;
  dateLastActive?: InputMaybe<Scalars['date']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSuperAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastSeenChangelog?: InputMaybe<Scalars['String']['input']>;
  profilePic?: InputMaybe<Scalars['String']['input']>;
  responsibilityId?: InputMaybe<Responsibilities_Enum>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Scalars['date']['input']>;
  dateLastActive?: InputMaybe<Scalars['date']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSuperAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastSeenChangelog?: InputMaybe<Scalars['String']['input']>;
  profilePic?: InputMaybe<Scalars['String']['input']>;
  responsibilityId?: InputMaybe<Responsibilities_Enum>;
};

/** update columns of table "users" */
export type Users_Update_Column =
  /** column name */
  | 'auth0Id'
  /** column name */
  | 'dateCreated'
  /** column name */
  | 'dateLastActive'
  /** column name */
  | 'displayName'
  /** column name */
  | 'email'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'isSuperAdmin'
  /** column name */
  | 'lastName'
  /** column name */
  | 'lastSeenChangelog'
  /** column name */
  | 'profilePic'
  /** column name */
  | 'responsibilityId';

export type Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type CheckNullBranchesQueryVariables = Exact<{
  siteId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckNullBranchesQuery = { __typename?: 'query_root', siteInstances: Array<{ __typename?: 'siteInstances', gitBranch?: string | null, authorId?: string | null }> };

export type DeleteNullBranchesFromSiteMutationVariables = Exact<{
  siteId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteNullBranchesFromSiteMutation = { __typename?: 'mutation_root', delete_siteInstances?: { __typename?: 'siteInstances_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'siteInstances', gitBranch?: string | null, authorId?: string | null }> } | null };

export type DataChangesSubscriptionVariables = Exact<{
  instanceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type DataChangesSubscription = { __typename?: 'subscription_root', dataChanges: Array<{ __typename?: 'dataChanges', id: string, date: string, patches: Record<string, unknown> | unknown[], userId?: string | null }> };

export type GetMySitesQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetMySitesQuery = { __typename?: 'query_root', sites: Array<{ __typename?: 'sites', id: string, title?: string | null }> };

export type SiteInstancesQueryVariables = Exact<{
  siteId: Scalars['String']['input'];
}>;


export type SiteInstancesQuery = { __typename?: 'query_root', site?: { __typename?: 'sites', latestInstanceId?: string | null, siteInstances: Array<{ __typename?: 'siteInstances', id: string, dateCreated?: string | null, dateUpdated?: string | null, appState?: { __typename?: 'dataSets', id: string } | null, siteDeployment?: { __typename?: 'siteDeployments', id: string, gitBranch?: string | null, gitSha?: string | null, dateCreated: string, prUrl?: string | null, url: string } | null }> } | null };

export type UserInfoSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UserInfoSubscription = { __typename?: 'subscription_root', user?: { __typename?: 'users', email: string, firstName?: string | null, lastName?: string | null, displayName?: string | null, profilePic?: string | null, responsibilityId?: Responsibilities_Enum | null, dateCreated?: string | null, sites: Array<{ __typename?: 'sitesUsers', roleId: Roles_Enum, siteId: string }> } | null };

export type CurrentBranchInfoSubscriptionVariables = Exact<{
  instanceId: Scalars['String']['input'];
}>;


export type CurrentBranchInfoSubscription = { __typename?: 'subscription_root', siteInstance?: { __typename?: 'siteInstances', statusId?: SiteInstanceStatuses_Enum | null, lastCommittedDataChangeId?: string | null, lastOneDataChanges: Array<{ __typename?: 'dataChanges', id: string }>, histories: Array<{ __typename?: 'siteInstanceHistories', id: string, statusId: SiteInstanceStatuses_Enum, title?: string | null, date: string, userId?: string | null, user?: { __typename?: 'users', displayName?: string | null, profilePic?: string | null } | null }> } | null };

export type SiteStatusSubscriptionVariables = Exact<{
  siteId: Scalars['String']['input'];
}>;


export type SiteStatusSubscription = { __typename?: 'subscription_root', site?: { __typename?: 'sites', status: SiteStatuses_Enum } | null };

export type DesignSrcStatusSubscriptionVariables = Exact<{
  fileId: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  version: Scalars['String']['input'];
}>;


export type DesignSrcStatusSubscription = { __typename?: 'subscription_root', designSrc?: { __typename?: 'designSourceFileFigma', errorMessage?: string | null, status: { __typename?: 'designSourceFileStatus', id: string } } | null };

export type SiteUsersSubscriptionSubscriptionVariables = Exact<{
  siteId: Scalars['String']['input'];
}>;


export type SiteUsersSubscriptionSubscription = { __typename?: 'subscription_root', site?: { __typename?: 'sites', users: Array<{ __typename?: 'sitesUsers', role: { __typename?: 'roles', id: string, title: string }, user: { __typename?: 'users', id: string, email: string, firstName?: string | null, lastName?: string | null, displayName?: string | null, profilePic?: string | null, dateCreated?: string | null, dateLastActive?: string | null, responsibility?: { __typename?: 'responsibilities', id: string, title: string } | null } }> } | null };

export type CurrentSiteUserSubscriptionVariables = Exact<{
  siteId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type CurrentSiteUserSubscription = { __typename?: 'subscription_root', site?: { __typename?: 'sites', users: Array<{ __typename?: 'sitesUsers', role: { __typename?: 'roles', id: string, title: string }, user: { __typename?: 'users', id: string, email: string, firstName?: string | null, lastName?: string | null, displayName?: string | null, profilePic?: string | null, dateCreated?: string | null, dateLastActive?: string | null, responsibility?: { __typename?: 'responsibilities', id: string, title: string } | null } }> } | null };

export type CurrentUserSubscriptionVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type CurrentUserSubscription = { __typename?: 'subscription_root', users: Array<{ __typename?: 'users', id: string, email: string, firstName?: string | null, lastName?: string | null, displayName?: string | null, profilePic?: string | null, dateCreated?: string | null, responsibility?: { __typename?: 'responsibilities', id: string, title: string } | null }> };

export type SiteUsersQueryVariables = Exact<{
  siteId: Scalars['String']['input'];
}>;


export type SiteUsersQuery = { __typename?: 'query_root', site?: { __typename?: 'sites', users: Array<{ __typename?: 'sitesUsers', role: { __typename?: 'roles', id: string, title: string }, user: { __typename?: 'users', id: string, email: string, firstName?: string | null, lastName?: string | null, displayName?: string | null, profilePic?: string | null, dateCreated?: string | null, dateLastActive?: string | null, responsibility?: { __typename?: 'responsibilities', id: string, title: string } | null } }> } | null, roles: Array<{ __typename?: 'roles', id: string, title: string }> };

export type SetUserRoleMutationVariables = Exact<{
  siteId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  roleId?: InputMaybe<Roles_Enum>;
}>;


export type SetUserRoleMutation = { __typename?: 'mutation_root', update_sitesUsers_by_pk?: { __typename?: 'sitesUsers', role: { __typename?: 'roles', id: string, title: string } } | null };

export type SetUserResponsibilityMutationVariables = Exact<{
  id: Scalars['String']['input'];
  responsibilityId?: InputMaybe<Responsibilities_Enum>;
}>;


export type SetUserResponsibilityMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', responsibility?: { __typename?: 'responsibilities', id: string, title: string } | null } | null };

export type RemoveUserFromSiteMutationVariables = Exact<{
  siteId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type RemoveUserFromSiteMutation = { __typename?: 'mutation_root', delete_sitesUsers_by_pk?: { __typename?: 'sitesUsers', userId: string } | null };

export const UserInfoFragFragmentDoc = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfoFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePic"}},{"kind":"Field","name":{"kind":"Name","value":"responsibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateLastActive"}}]}}]} as unknown as DocumentNode;
export const CheckNullBranchesDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checkNullBranches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteInstances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gitBranch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"siteId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"statusId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PROPOSED"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gitBranch"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCheckNullBranchesQuery__
 *
 * To run a query within a React component, call `useCheckNullBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckNullBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckNullBranchesQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useCheckNullBranchesQuery(baseOptions?: Apollo.QueryHookOptions<CheckNullBranchesQuery, CheckNullBranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckNullBranchesQuery, CheckNullBranchesQueryVariables>(CheckNullBranchesDocument, options);
      }
export function useCheckNullBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckNullBranchesQuery, CheckNullBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckNullBranchesQuery, CheckNullBranchesQueryVariables>(CheckNullBranchesDocument, options);
        }
export function useCheckNullBranchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckNullBranchesQuery, CheckNullBranchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckNullBranchesQuery, CheckNullBranchesQueryVariables>(CheckNullBranchesDocument, options);
        }
export type CheckNullBranchesQueryHookResult = ReturnType<typeof useCheckNullBranchesQuery>;
export type CheckNullBranchesLazyQueryHookResult = ReturnType<typeof useCheckNullBranchesLazyQuery>;
export type CheckNullBranchesSuspenseQueryHookResult = ReturnType<typeof useCheckNullBranchesSuspenseQuery>;
export type CheckNullBranchesQueryResult = Apollo.QueryResult<CheckNullBranchesQuery, CheckNullBranchesQueryVariables>;
export function refetchCheckNullBranchesQuery(variables?: CheckNullBranchesQueryVariables) {
      return { query: CheckNullBranchesDocument, variables: variables }
    }
export const DeleteNullBranchesFromSiteDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteNullBranchesFromSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_siteInstances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gitBranch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"siteId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"statusId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PROPOSED"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gitBranch"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}}]}}]}}]}}]} as unknown as DocumentNode;
export type DeleteNullBranchesFromSiteMutationFn = Apollo.MutationFunction<DeleteNullBranchesFromSiteMutation, DeleteNullBranchesFromSiteMutationVariables>;

/**
 * __useDeleteNullBranchesFromSiteMutation__
 *
 * To run a mutation, you first call `useDeleteNullBranchesFromSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNullBranchesFromSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNullBranchesFromSiteMutation, { data, loading, error }] = useDeleteNullBranchesFromSiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useDeleteNullBranchesFromSiteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNullBranchesFromSiteMutation, DeleteNullBranchesFromSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNullBranchesFromSiteMutation, DeleteNullBranchesFromSiteMutationVariables>(DeleteNullBranchesFromSiteDocument, options);
      }
export type DeleteNullBranchesFromSiteMutationHookResult = ReturnType<typeof useDeleteNullBranchesFromSiteMutation>;
export type DeleteNullBranchesFromSiteMutationResult = Apollo.MutationResult<DeleteNullBranchesFromSiteMutation>;
export type DeleteNullBranchesFromSiteMutationOptions = Apollo.BaseMutationOptions<DeleteNullBranchesFromSiteMutation, DeleteNullBranchesFromSiteMutationVariables>;
export const DataChangesDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"DataChanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instanceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"instanceId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instanceId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"patches"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useDataChangesSubscription__
 *
 * To run a query within a React component, call `useDataChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDataChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataChangesSubscription({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDataChangesSubscription(baseOptions: Apollo.SubscriptionHookOptions<DataChangesSubscription, DataChangesSubscriptionVariables> & ({ variables: DataChangesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DataChangesSubscription, DataChangesSubscriptionVariables>(DataChangesDocument, options);
      }
export type DataChangesSubscriptionHookResult = ReturnType<typeof useDataChangesSubscription>;
export type DataChangesSubscriptionResult = Apollo.SubscriptionResult<DataChangesSubscription>;
export const GetMySitesDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMySites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetMySitesQuery__
 *
 * To run a query within a React component, call `useGetMySitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySitesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMySitesQuery(baseOptions: Apollo.QueryHookOptions<GetMySitesQuery, GetMySitesQueryVariables> & ({ variables: GetMySitesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySitesQuery, GetMySitesQueryVariables>(GetMySitesDocument, options);
      }
export function useGetMySitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySitesQuery, GetMySitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySitesQuery, GetMySitesQueryVariables>(GetMySitesDocument, options);
        }
export function useGetMySitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySitesQuery, GetMySitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMySitesQuery, GetMySitesQueryVariables>(GetMySitesDocument, options);
        }
export type GetMySitesQueryHookResult = ReturnType<typeof useGetMySitesQuery>;
export type GetMySitesLazyQueryHookResult = ReturnType<typeof useGetMySitesLazyQuery>;
export type GetMySitesSuspenseQueryHookResult = ReturnType<typeof useGetMySitesSuspenseQuery>;
export type GetMySitesQueryResult = Apollo.QueryResult<GetMySitesQuery, GetMySitesQueryVariables>;
export function refetchGetMySitesQuery(variables: GetMySitesQueryVariables) {
      return { query: GetMySitesDocument, variables: variables }
    }
export const SiteInstancesDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SiteInstances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"site"},"name":{"kind":"Name","value":"sites_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latestInstanceId"}},{"kind":"Field","name":{"kind":"Name","value":"siteInstances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"appState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"siteDeployment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gitBranch"}},{"kind":"Field","name":{"kind":"Name","value":"gitSha"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"prUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useSiteInstancesQuery__
 *
 * To run a query within a React component, call `useSiteInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteInstancesQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteInstancesQuery(baseOptions: Apollo.QueryHookOptions<SiteInstancesQuery, SiteInstancesQueryVariables> & ({ variables: SiteInstancesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteInstancesQuery, SiteInstancesQueryVariables>(SiteInstancesDocument, options);
      }
export function useSiteInstancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteInstancesQuery, SiteInstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteInstancesQuery, SiteInstancesQueryVariables>(SiteInstancesDocument, options);
        }
export function useSiteInstancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiteInstancesQuery, SiteInstancesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteInstancesQuery, SiteInstancesQueryVariables>(SiteInstancesDocument, options);
        }
export type SiteInstancesQueryHookResult = ReturnType<typeof useSiteInstancesQuery>;
export type SiteInstancesLazyQueryHookResult = ReturnType<typeof useSiteInstancesLazyQuery>;
export type SiteInstancesSuspenseQueryHookResult = ReturnType<typeof useSiteInstancesSuspenseQuery>;
export type SiteInstancesQueryResult = Apollo.QueryResult<SiteInstancesQuery, SiteInstancesQueryVariables>;
export function refetchSiteInstancesQuery(variables: SiteInstancesQueryVariables) {
      return { query: SiteInstancesDocument, variables: variables }
    }
export const UserInfoDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UserInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePic"}},{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleId"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"responsibilityId"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUserInfoSubscription__
 *
 * To run a query within a React component, call `useUserInfoSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserInfoSubscription(baseOptions: Apollo.SubscriptionHookOptions<UserInfoSubscription, UserInfoSubscriptionVariables> & ({ variables: UserInfoSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserInfoSubscription, UserInfoSubscriptionVariables>(UserInfoDocument, options);
      }
export type UserInfoSubscriptionHookResult = ReturnType<typeof useUserInfoSubscription>;
export type UserInfoSubscriptionResult = Apollo.SubscriptionResult<UserInfoSubscription>;
export const CurrentBranchInfoDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CurrentBranchInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instanceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"siteInstance"},"name":{"kind":"Name","value":"siteInstances_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instanceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statusId"}},{"kind":"Field","name":{"kind":"Name","value":"lastCommittedDataChangeId"}},{"kind":"Field","alias":{"kind":"Name","value":"lastOneDataChanges"},"name":{"kind":"Name","value":"dataChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"histories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"statusId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePic"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCurrentBranchInfoSubscription__
 *
 * To run a query within a React component, call `useCurrentBranchInfoSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBranchInfoSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBranchInfoSubscription({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useCurrentBranchInfoSubscription(baseOptions: Apollo.SubscriptionHookOptions<CurrentBranchInfoSubscription, CurrentBranchInfoSubscriptionVariables> & ({ variables: CurrentBranchInfoSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CurrentBranchInfoSubscription, CurrentBranchInfoSubscriptionVariables>(CurrentBranchInfoDocument, options);
      }
export type CurrentBranchInfoSubscriptionHookResult = ReturnType<typeof useCurrentBranchInfoSubscription>;
export type CurrentBranchInfoSubscriptionResult = Apollo.SubscriptionResult<CurrentBranchInfoSubscription>;
export const SiteStatusDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"siteStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"site"},"name":{"kind":"Name","value":"sites_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useSiteStatusSubscription__
 *
 * To run a query within a React component, call `useSiteStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSiteStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteStatusSubscription({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<SiteStatusSubscription, SiteStatusSubscriptionVariables> & ({ variables: SiteStatusSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SiteStatusSubscription, SiteStatusSubscriptionVariables>(SiteStatusDocument, options);
      }
export type SiteStatusSubscriptionHookResult = ReturnType<typeof useSiteStatusSubscription>;
export type SiteStatusSubscriptionResult = Apollo.SubscriptionResult<SiteStatusSubscription>;
export const DesignSrcStatusDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"designSrcStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"designSrc"},"name":{"kind":"Name","value":"designSourceFileFigma_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}}},{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useDesignSrcStatusSubscription__
 *
 * To run a query within a React component, call `useDesignSrcStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDesignSrcStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignSrcStatusSubscription({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      siteId: // value for 'siteId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDesignSrcStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<DesignSrcStatusSubscription, DesignSrcStatusSubscriptionVariables> & ({ variables: DesignSrcStatusSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DesignSrcStatusSubscription, DesignSrcStatusSubscriptionVariables>(DesignSrcStatusDocument, options);
      }
export type DesignSrcStatusSubscriptionHookResult = ReturnType<typeof useDesignSrcStatusSubscription>;
export type DesignSrcStatusSubscriptionResult = Apollo.SubscriptionResult<DesignSrcStatusSubscription>;
export const SiteUsersSubscriptionDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SiteUsersSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"site"},"name":{"kind":"Name","value":"sites_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfoFrag"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfoFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePic"}},{"kind":"Field","name":{"kind":"Name","value":"responsibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateLastActive"}}]}}]} as unknown as DocumentNode;

/**
 * __useSiteUsersSubscriptionSubscription__
 *
 * To run a query within a React component, call `useSiteUsersSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSiteUsersSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteUsersSubscriptionSubscription({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteUsersSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<SiteUsersSubscriptionSubscription, SiteUsersSubscriptionSubscriptionVariables> & ({ variables: SiteUsersSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SiteUsersSubscriptionSubscription, SiteUsersSubscriptionSubscriptionVariables>(SiteUsersSubscriptionDocument, options);
      }
export type SiteUsersSubscriptionSubscriptionHookResult = ReturnType<typeof useSiteUsersSubscriptionSubscription>;
export type SiteUsersSubscriptionSubscriptionResult = Apollo.SubscriptionResult<SiteUsersSubscriptionSubscription>;
export const CurrentSiteUserDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CurrentSiteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"site"},"name":{"kind":"Name","value":"sites_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfoFrag"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfoFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePic"}},{"kind":"Field","name":{"kind":"Name","value":"responsibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateLastActive"}}]}}]} as unknown as DocumentNode;

/**
 * __useCurrentSiteUserSubscription__
 *
 * To run a query within a React component, call `useCurrentSiteUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCurrentSiteUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentSiteUserSubscription({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCurrentSiteUserSubscription(baseOptions: Apollo.SubscriptionHookOptions<CurrentSiteUserSubscription, CurrentSiteUserSubscriptionVariables> & ({ variables: CurrentSiteUserSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CurrentSiteUserSubscription, CurrentSiteUserSubscriptionVariables>(CurrentSiteUserDocument, options);
      }
export type CurrentSiteUserSubscriptionHookResult = ReturnType<typeof useCurrentSiteUserSubscription>;
export type CurrentSiteUserSubscriptionResult = Apollo.SubscriptionResult<CurrentSiteUserSubscription>;
export const CurrentUserDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CurrentUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePic"}},{"kind":"Field","name":{"kind":"Name","value":"responsibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCurrentUserSubscription__
 *
 * To run a query within a React component, call `useCurrentUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCurrentUserSubscription(baseOptions: Apollo.SubscriptionHookOptions<CurrentUserSubscription, CurrentUserSubscriptionVariables> & ({ variables: CurrentUserSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CurrentUserSubscription, CurrentUserSubscriptionVariables>(CurrentUserDocument, options);
      }
export type CurrentUserSubscriptionHookResult = ReturnType<typeof useCurrentUserSubscription>;
export type CurrentUserSubscriptionResult = Apollo.SubscriptionResult<CurrentUserSubscription>;
export const SiteUsersDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SiteUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"site"},"name":{"kind":"Name","value":"sites_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfoFrag"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfoFrag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePic"}},{"kind":"Field","name":{"kind":"Name","value":"responsibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateLastActive"}}]}}]} as unknown as DocumentNode;

/**
 * __useSiteUsersQuery__
 *
 * To run a query within a React component, call `useSiteUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteUsersQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteUsersQuery(baseOptions: Apollo.QueryHookOptions<SiteUsersQuery, SiteUsersQueryVariables> & ({ variables: SiteUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteUsersQuery, SiteUsersQueryVariables>(SiteUsersDocument, options);
      }
export function useSiteUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteUsersQuery, SiteUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteUsersQuery, SiteUsersQueryVariables>(SiteUsersDocument, options);
        }
export function useSiteUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiteUsersQuery, SiteUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteUsersQuery, SiteUsersQueryVariables>(SiteUsersDocument, options);
        }
export type SiteUsersQueryHookResult = ReturnType<typeof useSiteUsersQuery>;
export type SiteUsersLazyQueryHookResult = ReturnType<typeof useSiteUsersLazyQuery>;
export type SiteUsersSuspenseQueryHookResult = ReturnType<typeof useSiteUsersSuspenseQuery>;
export type SiteUsersQueryResult = Apollo.QueryResult<SiteUsersQuery, SiteUsersQueryVariables>;
export function refetchSiteUsersQuery(variables: SiteUsersQueryVariables) {
      return { query: SiteUsersDocument, variables: variables }
    }
export const SetUserRoleDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetUserRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"roles_enum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_sitesUsers_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode;
export type SetUserRoleMutationFn = Apollo.MutationFunction<SetUserRoleMutation, SetUserRoleMutationVariables>;

/**
 * __useSetUserRoleMutation__
 *
 * To run a mutation, you first call `useSetUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserRoleMutation, { data, loading, error }] = useSetUserRoleMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useSetUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<SetUserRoleMutation, SetUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserRoleMutation, SetUserRoleMutationVariables>(SetUserRoleDocument, options);
      }
export type SetUserRoleMutationHookResult = ReturnType<typeof useSetUserRoleMutation>;
export type SetUserRoleMutationResult = Apollo.MutationResult<SetUserRoleMutation>;
export type SetUserRoleMutationOptions = Apollo.BaseMutationOptions<SetUserRoleMutation, SetUserRoleMutationVariables>;
export const SetUserResponsibilityDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetUserResponsibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responsibilityId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"responsibilities_enum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"responsibilityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responsibilityId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responsibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode;
export type SetUserResponsibilityMutationFn = Apollo.MutationFunction<SetUserResponsibilityMutation, SetUserResponsibilityMutationVariables>;

/**
 * __useSetUserResponsibilityMutation__
 *
 * To run a mutation, you first call `useSetUserResponsibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserResponsibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserResponsibilityMutation, { data, loading, error }] = useSetUserResponsibilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      responsibilityId: // value for 'responsibilityId'
 *   },
 * });
 */
export function useSetUserResponsibilityMutation(baseOptions?: Apollo.MutationHookOptions<SetUserResponsibilityMutation, SetUserResponsibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserResponsibilityMutation, SetUserResponsibilityMutationVariables>(SetUserResponsibilityDocument, options);
      }
export type SetUserResponsibilityMutationHookResult = ReturnType<typeof useSetUserResponsibilityMutation>;
export type SetUserResponsibilityMutationResult = Apollo.MutationResult<SetUserResponsibilityMutation>;
export type SetUserResponsibilityMutationOptions = Apollo.BaseMutationOptions<SetUserResponsibilityMutation, SetUserResponsibilityMutationVariables>;
export const RemoveUserFromSiteDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUserFromSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_sitesUsers_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode;
export type RemoveUserFromSiteMutationFn = Apollo.MutationFunction<RemoveUserFromSiteMutation, RemoveUserFromSiteMutationVariables>;

/**
 * __useRemoveUserFromSiteMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromSiteMutation, { data, loading, error }] = useRemoveUserFromSiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserFromSiteMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromSiteMutation, RemoveUserFromSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromSiteMutation, RemoveUserFromSiteMutationVariables>(RemoveUserFromSiteDocument, options);
      }
export type RemoveUserFromSiteMutationHookResult = ReturnType<typeof useRemoveUserFromSiteMutation>;
export type RemoveUserFromSiteMutationResult = Apollo.MutationResult<RemoveUserFromSiteMutation>;
export type RemoveUserFromSiteMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromSiteMutation, RemoveUserFromSiteMutationVariables>;